var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,74.85a173.34,173.34,0,0,0-34,16.38l95.73,201Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.82,78.51a172.28,172.28,0,0,0-31.57-9.84l-32,223.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.55,137.17q-3.69-5.1-7.73-9.91l-129.61,165Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6,202.54A173,173,0,0,0,404,163L251.21,292.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.29,187.08a174,174,0,0,0-7.72,44.81l177.64,60.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.32,149.24q-2.4,4-4.57,8.07l157.46,135Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,354.1a175.37,175.37,0,0,0,20.61,19.81l113.64-81.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.79,298.27A173.47,173.47,0,0,0,99,329.88l152.18-37.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1,406.73A173.9,173.9,0,0,0,247.42,413c.93,0,1.85,0,2.78,0l1-120.66C248,294.68,216,371,201.1,406.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.43,401.59A173.81,173.81,0,0,0,347,381.69l-95.77-89.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.66,369.34q3.29-2.91,6.43-6L251.21,292.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.89,338.89a173.37,173.37,0,0,0,22.94-45.77l-161.62-.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.72,254.63c.29-3.29.5-6.6.61-9.94L251.21,292.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.04,
    cy: 143.86,
    rx: 18.15,
    ry: 21.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.04,
    cy: 143.86,
    rx: 15,
    ry: 17.58,
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.08,153.08V156h-1.8V153.1A8.77,8.77,0,0,1,360.9,151l1-2.6a7.72,7.72,0,0,0,4.39,1.95v-5.15c-2.44-.69-5-1.62-5-5.2,0-2.62,1.62-4.91,5-5.3v-2.91h1.8v2.86a8.44,8.44,0,0,1,4.46,1.57l-.9,2.6a8.31,8.31,0,0,0-3.56-1.39v5.2c2.44.7,5.1,1.6,5.1,5.17C373.18,150.4,371.53,152.66,368.08,153.08Zm-1.8-11v-4.58a2.33,2.33,0,0,0-2.22,2.34C364.06,141.06,365,141.62,366.28,142.06Zm4.08,5.95c0-1.27-1-1.86-2.28-2.3v4.56C369.68,150,370.36,149.11,370.36,148Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.66,
    cy: 345.06,
    rx: 18.15,
    ry: 21.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.66,
    cy: 345.06,
    rx: 15,
    ry: 17.58,
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,354.27v2.88h-1.8V354.3a8.78,8.78,0,0,1-5.38-2.14l1-2.6a7.73,7.73,0,0,0,4.39,2v-5.15c-2.44-.7-5.05-1.62-5.05-5.2,0-2.63,1.62-4.92,5.05-5.3V333h1.8v2.86a8.38,8.38,0,0,1,4.46,1.57l-.9,2.59a8.29,8.29,0,0,0-3.56-1.38v5.19c2.44.7,5.09,1.6,5.09,5.18C128.79,351.59,127.15,353.86,123.7,354.27Zm-1.8-11v-4.58a2.33,2.33,0,0,0-2.22,2.34C119.68,342.25,120.62,342.82,121.9,343.25ZM126,349.2c0-1.26-1-1.85-2.28-2.29v4.56C125.3,351.18,126,350.31,126,349.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.97,
    cy: 235.87,
    rx: 18.15,
    ry: 21.27,
    transform: "translate(-15.62 444.71) rotate(-60.05)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.97,
    cy: 235.87,
    rx: 15,
    ry: 17.58,
    transform: "translate(-15.62 444.72) rotate(-60.05)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,239.57,388,241l-.9,1.56-2.48-1.42a8.74,8.74,0,0,1-4.53,3.59l-1.76-2.15a7.81,7.81,0,0,0,3.89-2.83l-4.46-2.57c-1.82,1.76-3.93,3.56-7,1.78-2.28-1.31-3.45-3.87-2.07-7l-2.52-1.45.9-1.56,2.47,1.43a8.41,8.41,0,0,1,3.59-3.08l1.8,2.08a8.18,8.18,0,0,0-3,2.38l4.5,2.6c1.82-1.76,3.93-3.62,7-1.83C385.7,233.82,386.84,236.38,385.47,239.57ZM375,235.63l-4-2.29a2.31,2.31,0,0,0,.92,3.09C373.05,237.05,374,236.52,375,235.63Zm7.19-.57c-1.09-.63-2.09-.09-3.13.84l4,2.27C383.6,236.64,383.18,235.61,382.22,235.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.4,
    cy: 204.69,
    rx: 21.5,
    ry: 21.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.4,
    cy: 204.69,
    rx: 17.78,
    ry: 17.58,
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.63,213.91v2.88H300.5v-2.86a11.47,11.47,0,0,1-6.37-2.13l1.17-2.6a10,10,0,0,0,5.2,2V206c-2.89-.69-6-1.62-6-5.19,0-2.63,1.92-4.92,6-5.31v-2.91h2.13v2.86a11.25,11.25,0,0,1,5.29,1.57l-1.07,2.6a10.93,10.93,0,0,0-4.22-1.39v5.2c2.89.7,6,1.6,6,5.17C308.67,211.23,306.72,213.49,302.63,213.91Zm-2.13-11v-4.58c-1.85.28-2.63,1.21-2.63,2.34S299,202.45,300.5,202.89Zm4.84,6c0-1.27-1.14-1.86-2.71-2.3v4.56C304.53,210.82,305.34,209.94,305.34,208.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.85,
    cy: 293.71,
    rx: 21.5,
    ry: 21.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.85,
    cy: 293.71,
    rx: 17.78,
    ry: 17.58,
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.09,302.93v2.88H196V303a11.48,11.48,0,0,1-6.37-2.14l1.17-2.6a10,10,0,0,0,5.2,1.95V295c-2.88-.7-6-1.62-6-5.2,0-2.63,1.93-4.92,6-5.31v-2.9h2.14v2.85a11.33,11.33,0,0,1,5.28,1.57l-1.07,2.6a11,11,0,0,0-4.21-1.39v5.2c2.89.7,6,1.6,6,5.18C204.13,300.25,202.17,302.52,198.09,302.93Zm-2.14-11v-4.58c-1.84.28-2.62,1.21-2.62,2.34S194.45,291.47,196,291.91Zm4.85,5.95c0-1.26-1.15-1.85-2.71-2.29v4.55C200,299.84,200.8,299,200.8,297.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.47,
    cy: 248.02,
    rx: 21.5,
    ry: 21.27,
    transform: "translate(-97.78 67.2) rotate(-25.69)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.47,
    cy: 248.02,
    rx: 17.78,
    ry: 17.58,
    transform: "translate(-97.8 67.22) rotate(-25.69)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,255.79l1.25,2.6-1.92.92-1.24-2.57a11.42,11.42,0,0,1-6.67.84l-.07-2.85a10,10,0,0,0,5.53-.5l-2.23-4.63c-2.9.62-6.09,1.13-7.65-2.1-1.13-2.36-.39-5.26,3.1-7.37l-1.26-2.62,1.92-.93,1.24,2.58a11.29,11.29,0,0,1,5.44-.88l.17,2.81a11,11,0,0,0-4.4.57L99,246.35c2.9-.63,6.13-1.18,7.68,2.05C107.86,250.76,107.08,253.65,103.58,255.79Zm-6.7-9-2-4.13c-1.55,1.06-1.85,2.23-1.36,3.25S95.33,247.05,96.88,246.79Zm6.94,3.26c-.55-1.14-1.83-1.18-3.43-.89l2,4.1C104,252.18,104.3,251.05,103.82,250.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.45,211.26a15.46,15.46,0,1,1-20-8.42A15.37,15.37,0,0,1,175.45,211.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,212.26a12.78,12.78,0,1,1-16.57-7A12.7,12.7,0,0,1,173,212.26Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,222.84l.77,1.92-1.42.58-.76-1.91a8.28,8.28,0,0,1-4.83.29l.08-2.05a7.29,7.29,0,0,0,4-.09l-1.38-3.44c-2.11.31-4.43.53-5.39-1.86-.7-1.75,0-3.79,2.57-5.14l-.78-1.94,1.43-.57.76,1.9a8.24,8.24,0,0,1,4-.37l0,2a7.76,7.76,0,0,0-3.18.21l1.39,3.46c2.11-.31,4.46-.55,5.42,1.84C167.71,219.44,167,221.47,164.4,222.84ZM160,216.07,158.79,213c-1.15.69-1.42,1.51-1.12,2.27S158.9,216.18,160,216.07Zm4.83,2.66c-.34-.84-1.26-.93-2.42-.8l1.22,3C164.84,220.27,165.14,219.47,164.85,218.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.9,
    cy: 357.61,
    rx: 15.46,
    ry: 15.29,
    transform: "translate(-107.53 159.77) rotate(-21.91)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.9,
    cy: 357.61,
    rx: 12.78,
    ry: 12.64,
    transform: "translate(-107.54 159.8) rotate(-21.92)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.19,363.42l.77,1.92-1.42.58-.77-1.91a8.32,8.32,0,0,1-4.82.29l.08-2.05a7.29,7.29,0,0,0,4-.09l-1.38-3.44c-2.11.31-4.43.53-5.39-1.86-.7-1.75,0-3.79,2.57-5.14l-.78-1.94,1.42-.57.77,1.9a8.09,8.09,0,0,1,3.94-.37v2A7.76,7.76,0,0,0,358,353l1.39,3.46c2.11-.31,4.46-.55,5.42,1.83C365.5,360,364.81,362.05,362.19,363.42Zm-4.38-6.77-1.23-3.06c-1.15.69-1.42,1.51-1.12,2.27S356.69,356.76,357.81,356.65Zm4.83,2.66c-.34-.84-1.26-.93-2.42-.8l1.22,3C362.63,360.85,362.93,360.05,362.64,359.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.6,358.5a15.46,15.46,0,1,1-20-8.42A15.37,15.37,0,0,1,267.6,358.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,359.5a12.78,12.78,0,1,1-16.58-7A12.71,12.71,0,0,1,265.12,359.5Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.56,370.08l.77,1.92-1.42.58-.77-1.91a8.24,8.24,0,0,1-4.82.29l.08-2a7.26,7.26,0,0,0,4-.09L253,365.38c-2.11.32-4.42.53-5.38-1.86-.71-1.75,0-3.79,2.57-5.14l-.78-1.94,1.42-.57.77,1.9a8.2,8.2,0,0,1,3.94-.37v2a7.8,7.8,0,0,0-3.19.21l1.4,3.46c2.11-.31,4.45-.55,5.41,1.84C259.86,366.68,259.17,368.71,256.56,370.08Zm-4.38-6.77L251,360.25c-1.16.69-1.43,1.51-1.12,2.27S251.05,363.42,252.18,363.31ZM257,366c-.34-.84-1.26-.92-2.42-.8l1.22,3C257,367.51,257.3,366.71,257,366Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.76,
    cy: 105.34,
    rx: 14.3,
    ry: 14.15,
    transform: "translate(-19.32 110.93) rotate(-21.92)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,100.93a11.83,11.83,0,1,1-15.34-6.44A11.76,11.76,0,0,1,287.73,100.93Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.81,110.72l.71,1.78-1.32.53-.7-1.76a7.7,7.7,0,0,1-4.47.26l.08-1.89a6.79,6.79,0,0,0,3.7-.09l-1.28-3.18c-2,.29-4.1.49-5-1.72-.65-1.62,0-3.51,2.38-4.76l-.72-1.79,1.32-.53.71,1.76a7.45,7.45,0,0,1,3.64-.34v1.87a7.18,7.18,0,0,0-2.95.19l1.3,3.21c2-.29,4.12-.52,5,1.69C282.87,107.57,282.22,109.45,279.81,110.72Zm-4.06-6.27-1.13-2.83c-1.07.64-1.32,1.4-1,2.1S274.71,104.56,275.75,104.45Zm4.47,2.47c-.32-.78-1.17-.86-2.24-.74l1.13,2.81C280.21,108.34,280.49,107.6,280.22,106.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.95,
    cy: 158.63,
    rx: 11.84,
    ry: 13.87,
    transform: "translate(-45.06 112.4) rotate(-24.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.83,154.52c2.66,5.75.84,12.25-4.07,14.52s-11-.56-13.69-6.3-.84-12.25,4.07-14.52S239.17,148.77,241.83,154.52Z",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09,163.8l.79,1.71-1.07.49-.78-1.69a5.78,5.78,0,0,1-3.77.21l-.13-1.82a5,5,0,0,0,3.14,0l-1.41-3c-1.63.26-3.43.43-4.41-1.69A3.37,3.37,0,0,1,230,153.4l-.8-1.73,1.07-.49.78,1.69a5.54,5.54,0,0,1,3.07-.29l.18,1.79a5.25,5.25,0,0,0-2.49.15l1.42,3.08c1.64-.26,3.46-.45,4.43,1.67A3.4,3.4,0,0,1,236.09,163.8Zm-4.08-6-1.26-2.71a1.52,1.52,0,0,0-.67,2C230.42,157.78,231.13,157.86,232,157.77Zm4,2.4c-.34-.74-1.08-.83-2-.73l1.25,2.7C236.19,161.53,236.36,160.83,236.05,160.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.24,122.47l3.14,1.57c9,4.47,12,16.62,6.76,27.13s-16.76,15.41-25.73,10.94l-3.14-1.56c-9-4.47-12-16.62-6.75-27.13S151.27,118,160.24,122.47Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.76,
    cy: 141.51,
    rx: 21.27,
    ry: 18.15,
    transform: "translate(-43.14 213.33) rotate(-63.51)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.76,
    cy: 141.51,
    rx: 17.58,
    ry: 15,
    transform: "translate(-43.14 213.33) rotate(-63.51)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.58,150.22l-1.28,2.58-1.62-.8,1.28-2.56a8.66,8.66,0,0,1-3.86-4.31l2-1.88A7.73,7.73,0,0,0,147.2,147l2.29-4.61c-1.87-1.71-3.79-3.71-2.2-6.91,1.17-2.35,3.65-3.67,6.89-2.49l1.3-2.6,1.61.8-1.28,2.56a8.36,8.36,0,0,1,3.29,3.39l-2,1.92a8.24,8.24,0,0,0-2.57-2.83l-2.32,4.66c1.88,1.71,3.85,3.7,2.26,6.9C153.34,150.1,150.85,151.39,147.58,150.22Zm3.3-10.66,2.05-4.1a2.32,2.32,0,0,0-3,1.11C149.35,137.67,149.94,138.6,150.88,139.56Zm1,7.14c.56-1.12,0-2.08-1-3.06l-2,4.07C150.39,148.17,151.39,147.7,151.89,146.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.2,279.26l2.18,1.09c6.22,3.1,8.32,11.53,4.69,18.83s-11.64,10.7-17.86,7.6L407,305.69c-6.23-3.1-8.33-11.53-4.69-18.83S414,276.16,420.2,279.26Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.34,286.86c-3.64,7.3-1.54,15.73,4.69,18.83s14.22-.3,17.86-7.6,1.53-15.73-4.69-18.83S406,279.56,402.34,286.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.61,
    cy: 292.47,
    rx: 12.21,
    ry: 10.41,
    transform: "translate(-32.63 532.23) rotate(-63.51)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.41,298.52l-.9,1.79-1.11-.55.88-1.78a6.07,6.07,0,0,1-2.68-3l1.42-1.31a5.35,5.35,0,0,0,2.12,2.57l1.59-3.19c-1.3-1.19-2.63-2.58-1.52-4.8a3.59,3.59,0,0,1,4.78-1.73l.9-1.81,1.12.56-.89,1.78a5.78,5.78,0,0,1,2.28,2.35L418,290.75a5.81,5.81,0,0,0-1.78-2L414.65,292c1.3,1.19,2.67,2.57,1.56,4.8A3.61,3.61,0,0,1,411.41,298.52Zm2.29-7.4,1.42-2.85A1.63,1.63,0,0,0,413,289C412.63,289.81,413,290.45,413.7,291.12Zm.7,5c.39-.78,0-1.45-.71-2.13l-1.41,2.83A1.61,1.61,0,0,0,414.4,296.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296,273.68l3.14,1.56c9,4.47,12,16.62,6.75,27.13s-16.76,15.41-25.73,10.94L277,311.75c-9-4.47-12-16.62-6.75-27.13S287,269.21,296,273.68Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.26,284.62C265,295.13,268,307.28,277,311.75s20.49-.43,25.73-10.94S305,278.15,296,273.68,275.5,274.11,270.26,284.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.5,
    cy: 292.71,
    rx: 17.58,
    ry: 15,
    transform: "translate(-103.27 418.59) rotate(-63.51)",
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.32,301.43,282,304l-1.61-.81,1.27-2.55a8.72,8.72,0,0,1-3.86-4.32l2-1.88a7.84,7.84,0,0,0,3.06,3.71l2.3-4.61c-1.88-1.71-3.8-3.7-2.21-6.91,1.18-2.35,3.65-3.67,6.89-2.49l1.3-2.6,1.61.8-1.28,2.56a8.43,8.43,0,0,1,3.29,3.39l-2,1.93a8.07,8.07,0,0,0-2.57-2.83L288,292.05c1.87,1.71,3.84,3.7,2.25,6.9C289.08,301.3,286.59,302.6,283.32,301.43Zm3.3-10.67,2.05-4.1a2.33,2.33,0,0,0-3,1.11C285.09,288.88,285.68,289.8,286.62,290.76Zm1,7.15c.56-1.13,0-2.09-1-3.07l-2,4.08C286.14,299.38,287.14,298.9,287.63,297.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,122.59h-3.51c-10,0-18.15,9.52-18.15,21.27s8.13,21.27,18.15,21.27H367c10,0,18.14-9.52,18.14-21.27S377.06,122.59,367,122.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.66,323.79h-3.51c-10,0-18.15,9.52-18.15,21.27s8.13,21.27,18.15,21.27h3.51c10,0,18.14-9.53,18.14-21.27S132.68,323.79,122.66,323.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.54,225.25l-1.75,3c-5,8.69-.81,20.48,9.36,26.35s22.49,3.58,27.49-5.11c.14-.23,1.62-2.8,1.75-3,5-8.68.81-20.47-9.36-26.34S363.54,216.57,358.54,225.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,146l-2.08,1c-5.93,2.74-8.14,10.6-4.92,17.56s10.63,10.36,16.56,7.62l2.08-1c5.93-2.74,8.14-10.6,4.92-17.56S233.06,143.29,227.13,146Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-12",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.32,296.73l-.64,19.57a2.92,2.92,0,0,1-3,2.82l-21.42-.7-63-2.05L355,316.3h0l-14.93-.49a2.92,2.92,0,0,1-2.82-3l.64-19.58a2.92,2.92,0,0,1,3-2.82l56.21,1.84,45.39,1.48A2.92,2.92,0,0,1,445.32,296.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.92,315.92h0a.7.7,0,0,1-.68-.72l.69-21a.69.69,0,0,1,.72-.67h0a.7.7,0,0,1,.68.72l-.69,21A.7.7,0,0,1,390.92,315.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.21,314.27h0a.7.7,0,0,1-.68-.73l.69-21a.7.7,0,0,1,.72-.68h0a.71.71,0,0,1,.68.73l-.69,21A.7.7,0,0,1,340.21,314.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.38,314.44h0a.71.71,0,0,1-.68-.73l.69-21a.7.7,0,0,1,.72-.68h0a.7.7,0,0,1,.68.73l-.69,21A.7.7,0,0,1,345.38,314.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.87,314.68h0a.7.7,0,0,1-.68-.72l.69-21a.69.69,0,0,1,.72-.67h0a.7.7,0,0,1,.68.72l-.69,21A.7.7,0,0,1,352.87,314.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.13,315h0a.71.71,0,0,1-.68-.72l.69-21a.69.69,0,0,1,.72-.67h0a.7.7,0,0,1,.68.72l-.68,21A.71.71,0,0,1,361.13,315Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,315.25h0a.71.71,0,0,1-.68-.73l.69-21a.7.7,0,0,1,.72-.68h0a.7.7,0,0,1,.68.72l-.69,21A.7.7,0,0,1,370.17,315.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,315.57h0a.72.72,0,0,1-.68-.73l.69-21a.7.7,0,0,1,.72-.68h0a.7.7,0,0,1,.68.72l-.68,21A.72.72,0,0,1,380,315.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.36,295.14h0a.7.7,0,0,1,.68.72l-.68,21a.72.72,0,0,1-.73.68h0a.71.71,0,0,1-.68-.73l.69-21A.7.7,0,0,1,442.36,295.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19,295h0a.7.7,0,0,1,.68.73l-.68,21a.71.71,0,0,1-.73.68h0a.72.72,0,0,1-.68-.73l.69-21A.7.7,0,0,1,437.19,295Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.7,294.73h0a.7.7,0,0,1,.68.72l-.68,21a.7.7,0,0,1-.73.68h0a.7.7,0,0,1-.68-.72l.69-21A.7.7,0,0,1,429.7,294.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.44,294.46h0a.7.7,0,0,1,.68.72l-.69,21a.69.69,0,0,1-.72.67h0a.7.7,0,0,1-.68-.72l.69-21A.7.7,0,0,1,421.44,294.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.4,294.16h0a.71.71,0,0,1,.68.73l-.69,21a.7.7,0,0,1-.72.68h0a.7.7,0,0,1-.68-.73l.69-21A.7.7,0,0,1,412.4,294.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.59,293.84h0a.71.71,0,0,1,.68.73l-.69,21a.7.7,0,0,1-.72.68h0a.7.7,0,0,1-.68-.72l.69-21A.7.7,0,0,1,402.59,293.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.34,296.07,444.66,317a2.27,2.27,0,0,1-2.34,2.19l-102.91-3.36a2.26,2.26,0,0,1-2.09-1.62L393.63,316l.73-22.43,9.49.31-.73,22.43,2.75.09L406.6,294l7,.23-.73,22.43.92,0,.73-22.43,7.5.24-.73,22.43.61,0,.73-22.43,22.54.74A2.29,2.29,0,0,1,445.34,296.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.15,293.74l-102.91-3.36a2.26,2.26,0,0,0-2.33,2.19l-.68,20.89a2.1,2.1,0,0,0,.09.71l2.21.07.73-22.43,1.3,0-.73,22.44,3.22.1.73-22.43,2,.07-.73,22.43,5.32.17.73-22.43,2.9.1-.73,22.43,4.44.14.73-22.43,3.09.1L361.83,315l4.44.15.74-22.43,4.82.15-.74,22.43,2.22.08.74-22.43,7.34.24-.73,22.43,1.11,0,.73-22.43,62.71,2.05A2.25,2.25,0,0,0,443.15,293.74Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.44,
    y: 390.73,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.18,414.61h0a.71.71,0,0,1-.7-.7V392.86a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,381.18,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.74,
    y: 392.16,
    width: 1.4,
    height: 22.45,
    rx: 0.7,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.62,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21.05A.71.71,0,0,1,335.62,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.11,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,343.11,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,351.38,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,414.61h0a.71.71,0,0,1-.7-.7V392.86a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,360.42,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.24,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,370.24,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.92,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,431.92,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.75,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,426.75,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.26,392.16h0a.71.71,0,0,1,.7.7v21.05a.71.71,0,0,1-.7.7h0a.71.71,0,0,1-.71-.7V392.86A.71.71,0,0,1,419.26,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,392.16h0a.71.71,0,0,1,.7.7v21.05a.71.71,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,411,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.94,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.71.71,0,0,1-.7-.7V392.86A.71.71,0,0,1,401.94,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.13,392.16h0a.71.71,0,0,1,.7.7v21.05a.71.71,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,392.13,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.93,393V413.9a2.27,2.27,0,0,1-2.26,2.26h-103a2.25,2.25,0,0,1-2.14-1.55H383.9V392.17h9.49v22.44h2.75V392.17h7.05v22.44h.92V392.17h7.5v22.44h.61V392.17h22.55A2.22,2.22,0,0,1,434.93,393Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.67,390.73h-103a2.26,2.26,0,0,0-2.26,2.26V413.9a2.16,2.16,0,0,0,.12.71h2.21V392.16h1.3v22.45h3.21V392.17h2v22.44h5.32V392.17h2.9v22.44H349V392.17h3.1v22.44h4.44V392.17h4.83v22.44h2.22V392.17h7.34v22.44H372V392.17h62.74A2.25,2.25,0,0,0,432.67,390.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.54,
    y: 365.44,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.28,389.32h0a.7.7,0,0,1-.7-.7V367.57a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,370.28,389.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.54,389.32h0a.7.7,0,0,1-.7-.7V367.57a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,319.54,389.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.71,389.32h0a.7.7,0,0,1-.7-.7V367.57a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,324.71,389.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,389.32h0a.7.7,0,0,1-.7-.7V367.57a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21.05A.7.7,0,0,1,332.21,389.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,389.32h0a.7.7,0,0,1-.71-.7V367.57a.71.71,0,0,1,.71-.7h0a.71.71,0,0,1,.7.7v21.05A.7.7,0,0,1,340.48,389.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.52,389.32h0a.7.7,0,0,1-.7-.7V367.57a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21.05A.7.7,0,0,1,349.52,389.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.33,389.32h0a.7.7,0,0,1-.7-.7V367.57a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7v21.05A.7.7,0,0,1,359.33,389.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,366.87h0a.71.71,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V367.57A.7.7,0,0,1,421,366.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.84,366.87h0a.71.71,0,0,1,.71.7v21.05a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7V367.57A.71.71,0,0,1,415.84,366.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35,366.87h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V367.57A.7.7,0,0,1,408.35,366.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08,366.87h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V367.57A.7.7,0,0,1,400.08,366.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,366.87h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V367.57A.7.7,0,0,1,391,366.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.22,366.87h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V367.57A.71.71,0,0,1,381.22,366.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,367.71v20.9a2.26,2.26,0,0,1-2.26,2.26h-103a2.27,2.27,0,0,1-2.15-1.55H373V366.88h9.49v22.44h2.76V366.88h7v22.44h.92V366.88h7.51v22.44h.61V366.88h22.55A2.23,2.23,0,0,1,424,367.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.76,365.45h-103a2.25,2.25,0,0,0-2.26,2.26v20.9a2.15,2.15,0,0,0,.11.71h2.21V366.87h1.3v22.45h3.22V366.88h2v22.44h5.32V366.88h2.91v22.44h4.44V366.88h3.1v22.44h4.44V366.88h4.82v22.44h2.22V366.88H360v22.44h1.11V366.88h62.75A2.27,2.27,0,0,0,421.76,365.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.99,
    y: 340.16,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.73,364h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,375.73,364Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,364h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,325,364Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.16,364h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.71.7v21A.7.7,0,0,1,330.16,364Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.66,364h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,337.66,364Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 341.59,
    width: 1.4,
    height: 22.45,
    rx: 0.7,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,364h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,355,364Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.79,364h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,364.79,364Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.47,341.59h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,426.47,341.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.3,341.59h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,421.3,341.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.8,341.59h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,413.8,341.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.53,341.59h0a.7.7,0,0,1,.71.7v21a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,405.53,341.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.49,341.59h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,396.49,341.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.67,341.59h0a.7.7,0,0,1,.71.7v21a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,386.67,341.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.47,342.42v20.9a2.26,2.26,0,0,1-2.26,2.26h-103A2.27,2.27,0,0,1,322.1,364h56.34V341.59h9.49V364h2.76V341.59h7.05V364h.92V341.59h7.5V364h.61V341.59h22.55A2.23,2.23,0,0,1,429.47,342.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.21,340.16h-103a2.25,2.25,0,0,0-2.26,2.26v20.9a2.35,2.35,0,0,0,.11.71h2.22V341.59h1.3V364h3.21V341.59h2V364h5.32V341.59h2.9V364h4.44V341.59h3.1V364h4.44V341.59h4.82V364h2.23V341.59h7.34V364h1.12V341.59h62.74A2.26,2.26,0,0,0,427.21,340.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.38,318.28v19.59a2.91,2.91,0,0,1-2.91,2.92H315.82a2.92,2.92,0,0,1-2.92-2.92V318.28a2.91,2.91,0,0,1,2.92-2.91H417.47a2.91,2.91,0,0,1,2.78,2.05A2.71,2.71,0,0,1,420.38,318.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.64,339.24h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,366.64,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91,339.24h0a.7.7,0,0,1-.71-.7v-21a.7.7,0,0,1,.71-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,315.91,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.08,339.24h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,321.08,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.57,339.24h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,328.57,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.84,339.24h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,336.84,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88,339.24h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,345.88,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.7,339.24h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,355.7,339.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.38,316.8h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,417.38,316.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.21,316.8h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,412.21,316.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.72,316.8h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.71-.7v-21A.7.7,0,0,1,404.72,316.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.45,316.8h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,396.45,316.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4,316.8h0a.7.7,0,0,1,.71.7v21a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,387.4,316.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.59,316.8h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,377.59,316.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.39,317.63v20.9a2.26,2.26,0,0,1-2.26,2.26h-103a2.25,2.25,0,0,1-2.14-1.55h56.34V316.8h9.49v22.44h2.75V316.8h7v22.44h.92V316.8h7.5v22.44h.61V316.8h22.55A2.27,2.27,0,0,1,420.39,317.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.13,315.37h-103a2.26,2.26,0,0,0-2.26,2.26v20.9a2.08,2.08,0,0,0,.12.71h2.21V316.8h1.3v22.44h3.21V316.8h2v22.44h5.32V316.8H330v22.44h4.44V316.8h3.1v22.44H342V316.8h4.83v22.44H349V316.8h7.35v22.44h1.11V316.8h62.74A2.26,2.26,0,0,0,418.13,315.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.82,315.37h26.55c-.58,1-8.15,13.4-29.47,11.73v-8.82A2.91,2.91,0,0,1,315.82,315.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.11,292.24c-5.07,6.31-18,19.22-42.1,24.06h0l-14.93-.49a2.92,2.92,0,0,1-2.82-3l.64-19.58a2.92,2.92,0,0,1,3-2.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.02,
    y: 264.41,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    transform: "translate(-92.8 232.69) rotate(-32.19)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.71,286.57h0a.7.7,0,0,1-1-.22l-11.21-17.8a.71.71,0,0,1,.22-1h0a.7.7,0,0,1,1,.22l11.21,17.81A.69.69,0,0,1,362.71,286.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.77,313.61h0a.7.7,0,0,1-1-.22l-11.22-17.81a.72.72,0,0,1,.22-1h0a.71.71,0,0,1,1,.22L320,312.64A.7.7,0,0,1,319.77,313.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.15,310.85h0a.7.7,0,0,1-1-.22L312,292.82a.7.7,0,0,1,.22-1h0a.7.7,0,0,1,1,.22l11.21,17.8A.7.7,0,0,1,324.15,310.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,306.86h0a.69.69,0,0,1-1-.22l-11.22-17.81a.72.72,0,0,1,.22-1h0a.72.72,0,0,1,1,.22l11.21,17.81A.7.7,0,0,1,330.49,306.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.49,302.45h0a.7.7,0,0,1-1-.22l-11.21-17.81a.69.69,0,0,1,.22-1h0a.7.7,0,0,1,1,.22l11.21,17.81A.69.69,0,0,1,337.49,302.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.14,297.64h0a.7.7,0,0,1-1-.22L333,279.61a.72.72,0,0,1,.22-1h0a.7.7,0,0,1,1,.22l11.21,17.81A.7.7,0,0,1,345.14,297.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45,292.4h0a.71.71,0,0,1-1-.21l-11.21-17.81a.7.7,0,0,1,.22-1h0a.7.7,0,0,1,1,.22l11.21,17.81A.69.69,0,0,1,353.45,292.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.69,240.55h0a.7.7,0,0,1,1,.22l11.21,17.8a.71.71,0,0,1-.22,1h0a.7.7,0,0,1-1-.22l-11.21-17.81A.69.69,0,0,1,393.69,240.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.31,243.3h0a.7.7,0,0,1,1,.22l11.21,17.81a.7.7,0,0,1-.22,1h0a.72.72,0,0,1-1-.22l-11.21-17.81A.71.71,0,0,1,389.31,243.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,247.29h0a.72.72,0,0,1,1,.22l11.21,17.81a.71.71,0,0,1-.22,1h0a.7.7,0,0,1-1-.22l-11.21-17.81A.7.7,0,0,1,383,247.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,251.7h0a.7.7,0,0,1,1,.22l11.21,17.81a.69.69,0,0,1-.22,1h0a.69.69,0,0,1-1-.21l-11.22-17.81A.71.71,0,0,1,376,251.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.32,256.52h0a.7.7,0,0,1,1,.22l11.21,17.81a.69.69,0,0,1-.22,1h0a.7.7,0,0,1-1-.22L368.1,257.48A.69.69,0,0,1,368.32,256.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,261.75h0a.7.7,0,0,1,1,.22l11.21,17.81a.69.69,0,0,1-.22,1h0a.69.69,0,0,1-1-.22l-11.22-17.81A.71.71,0,0,1,360,261.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.67,239.65l11.14,17.69a2.25,2.25,0,0,1-.71,3.11L320,315.31a2.25,2.25,0,0,1-2.64-.17l47.68-30-12-19,8-5.06,12,19,2.33-1.47-12-19,6-3.75,12,19,.78-.49-12-19,6.35-4,12,19L389,270l-12-19,19.08-12A2.12,2.12,0,0,1,396.67,239.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.56,238.94,306.42,293.8a2.26,2.26,0,0,0-.7,3.12l11.13,17.68a1.92,1.92,0,0,0,.48.54L319.2,314l-12-19,1.1-.69,12,19,2.72-1.71-12-19,1.73-1.09,11.95,19,4.5-2.84-11.95-19,2.45-1.55,12,19,3.76-2.37-12-19,2.63-1.65,11.95,19,3.76-2.37-11.95-19,4.08-2.57,11.95,19L347.8,296l-11.95-19,6.21-3.92,12,19,.94-.59-11.95-19L396.1,239A2.24,2.24,0,0,0,393.56,238.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.19,
    y: 390.73,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.93,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21.05A.71.71,0,0,1,196.93,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,146.19,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,151.36,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,414.61h0a.71.71,0,0,1-.7-.7V392.86a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7v21.05A.71.71,0,0,1,158.85,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.12,414.61h0a.71.71,0,0,1-.7-.7V392.86a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,167.12,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,414.61h0a.71.71,0,0,1-.71-.7V392.86a.71.71,0,0,1,.71-.7h0a.71.71,0,0,1,.7.7v21.05A.71.71,0,0,1,176.17,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,414.61h0a.71.71,0,0,1-.7-.7V392.86a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,186,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,392.16h0a.71.71,0,0,1,.7.7v21.05a.71.71,0,0,1-.7.7h0a.71.71,0,0,1-.71-.7V392.86A.71.71,0,0,1,247.67,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.49,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.71.71,0,0,1-.7-.7V392.86A.71.71,0,0,1,242.49,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,235,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.73,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,226.73,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.69,392.16h0a.71.71,0,0,1,.7.7v21.05a.71.71,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,217.69,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.87,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,207.87,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67,393V413.9a2.26,2.26,0,0,1-2.26,2.26h-103a2.26,2.26,0,0,1-2.14-1.55h56.34V392.17h9.49v22.44h2.76V392.17h7v22.44h.92V392.17h7.5v22.44H228V392.17h22.55A2,2,0,0,1,250.67,393Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.41,390.73h-103a2.26,2.26,0,0,0-2.26,2.26V413.9a2.16,2.16,0,0,0,.12.71h2.21V392.16h1.3v22.45H150V392.17h2v22.44h5.32V392.17h2.9v22.44h4.45V392.17h3.09v22.44h4.45V392.17h4.82v22.44h2.22V392.17h7.35v22.44h1.11V392.17h62.74A2.25,2.25,0,0,0,248.41,390.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.67,
    y: 365.59,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41,389.47h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21A.7.7,0,0,1,199.41,389.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.67,389.47h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,148.67,389.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.84,389.47h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,153.84,389.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.33,389.47h0a.7.7,0,0,1-.7-.7v-21a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7v21A.7.7,0,0,1,161.33,389.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,389.47h0a.7.7,0,0,1-.7-.7v-21a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,169.6,389.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.65,389.47h0a.7.7,0,0,1-.71-.7v-21a.71.71,0,0,1,.71-.7h0a.71.71,0,0,1,.7.7v21A.7.7,0,0,1,178.65,389.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,389.47h0a.7.7,0,0,1-.7-.7v-21a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,188.46,389.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15,367h0a.71.71,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.71-.7v-21A.71.71,0,0,1,250.15,367Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,367h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.71.71,0,0,1,245,367Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.48,367h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,237.48,367Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.21,367h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,229.21,367Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17,367h0a.71.71,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,220.17,367Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,367h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,210.35,367Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.15,367.85v20.91a2.26,2.26,0,0,1-2.26,2.26h-103a2.26,2.26,0,0,1-2.14-1.55h56.34V367h9.49v22.44h2.76V367h7v22.44h.92V367h7.5v22.44h.61V367H253A2,2,0,0,1,253.15,367.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,365.59h-103a2.26,2.26,0,0,0-2.26,2.26v20.91a2.16,2.16,0,0,0,.12.71H148V367h1.3v22.45h3.22V367h2v22.44h5.32V367h2.9v22.44h4.45V367h3.09v22.44h4.45V367h4.82v22.44h2.22V367h7.35v22.44h1.11V367H253A2.25,2.25,0,0,0,250.89,365.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.57,
    y: 340.45,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.31,364.33h0a.7.7,0,0,1-.7-.7V342.58a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,190.31,364.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,364.33h0a.7.7,0,0,1-.7-.7V342.58a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7v21.05A.7.7,0,0,1,139.57,364.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.75,364.33h0a.7.7,0,0,1-.7-.7V342.58a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21.05A.7.7,0,0,1,144.75,364.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.24,364.33h0a.7.7,0,0,1-.7-.7V342.58a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,152.24,364.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51,364.33h0a.7.7,0,0,1-.7-.7V342.58a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,160.51,364.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.55,364.33h0a.7.7,0,0,1-.7-.7V342.58a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,169.55,364.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.37,364.33h0a.7.7,0,0,1-.7-.7V342.58a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,179.37,364.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05,341.88h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V342.58A.7.7,0,0,1,241.05,341.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,341.88h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V342.58A.7.7,0,0,1,235.88,341.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.39,341.88h0a.71.71,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.71-.7V342.58A.71.71,0,0,1,228.39,341.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,341.88h0a.71.71,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V342.58A.7.7,0,0,1,220.12,341.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.07,341.88h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V342.58A.71.71,0,0,1,211.07,341.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,341.88h0a.71.71,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V342.58A.7.7,0,0,1,201.26,341.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.06,342.71v20.91a2.27,2.27,0,0,1-2.26,2.26h-103a2.25,2.25,0,0,1-2.14-1.55H193V341.89h9.49v22.44h2.75V341.89h7v22.44h.92V341.89h7.5v22.44h.61V341.89H243.9A2.22,2.22,0,0,1,244.06,342.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.8,340.45h-103a2.26,2.26,0,0,0-2.26,2.26v20.91a2.16,2.16,0,0,0,.12.71h2.21V341.88h1.3v22.45h3.21V341.89h2v22.44h5.32V341.89h2.9v22.44h4.44V341.89h3.1v22.44h4.44V341.89h4.83v22.44h2.22V341.89H180v22.44h1.12V341.89H243.9A2.25,2.25,0,0,0,241.8,340.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.19,
    y: 315.31,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.93,339.19h0a.7.7,0,0,1-.7-.7V317.44a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21.05A.7.7,0,0,1,196.93,339.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,339.19h0a.7.7,0,0,1-.7-.7V317.44a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,146.19,339.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,339.19h0a.7.7,0,0,1-.7-.7V317.44a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,151.36,339.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,339.19h0a.7.7,0,0,1-.7-.7V317.44a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7v21.05A.7.7,0,0,1,158.85,339.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.12,339.19h0a.7.7,0,0,1-.7-.7V317.44a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,167.12,339.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,339.19h0a.7.7,0,0,1-.71-.7V317.44a.71.71,0,0,1,.71-.7h0a.71.71,0,0,1,.7.7v21.05A.7.7,0,0,1,176.17,339.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,339.19h0a.7.7,0,0,1-.7-.7V317.44a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,186,339.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,316.74h0a.71.71,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.71-.7V317.44A.71.71,0,0,1,247.67,316.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.49,316.74h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V317.44A.71.71,0,0,1,242.49,316.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,316.74h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V317.44A.7.7,0,0,1,235,316.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.73,316.74h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V317.44A.7.7,0,0,1,226.73,316.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.69,316.74h0a.71.71,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V317.44A.7.7,0,0,1,217.69,316.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.87,316.74h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V317.44A.7.7,0,0,1,207.87,316.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67,317.58v20.9a2.26,2.26,0,0,1-2.26,2.26h-103a2.26,2.26,0,0,1-2.14-1.55h56.34V316.75h9.49v22.44h2.76V316.75h7v22.44h.92V316.75h7.5v22.44H228V316.75h22.55A2,2,0,0,1,250.67,317.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.41,315.31h-103a2.27,2.27,0,0,0-2.26,2.27v20.9a2.16,2.16,0,0,0,.12.71h2.21V316.74h1.3v22.45H150V316.75h2v22.44h5.32V316.75h2.9v22.44h4.45V316.75h3.09v22.44h4.45V316.75h4.82v22.44h2.22V316.75h7.35v22.44h1.11V316.75h62.74A2.25,2.25,0,0,0,248.41,315.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,303.78l-48.93,7.88L90.55,320a2.84,2.84,0,0,1-3.26-2.35L85.41,306l-1.25-7.83a2.83,2.83,0,0,1,2.35-3.25L187,278.69a2.81,2.81,0,0,1,3.25,2.34l3.14,19.5A2.83,2.83,0,0,1,191.06,303.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.56,310.35h0a.7.7,0,0,1-.8-.58L136.41,289a.7.7,0,0,1,.58-.8h0a.69.69,0,0,1,.8.58l3.35,20.77A.7.7,0,0,1,140.56,310.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,318.41h0a.7.7,0,0,1-.81-.58l-3.34-20.78a.7.7,0,0,1,.58-.8h0a.7.7,0,0,1,.8.58l3.35,20.78A.7.7,0,0,1,90.47,318.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.57,317.59h0a.7.7,0,0,1-.8-.58l-3.35-20.78a.7.7,0,0,1,.58-.8h0a.7.7,0,0,1,.81.58l3.34,20.78A.7.7,0,0,1,95.57,317.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,316.4h0a.7.7,0,0,1-.8-.58L98.82,295a.7.7,0,0,1,.58-.8h0a.7.7,0,0,1,.81.58l3.34,20.77A.7.7,0,0,1,103,316.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.13,315.08h0a.69.69,0,0,1-.8-.58L107,293.73a.69.69,0,0,1,.58-.81h0a.7.7,0,0,1,.8.58l3.35,20.78A.7.7,0,0,1,111.13,315.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.06,313.65h0a.7.7,0,0,1-.8-.58l-3.35-20.78a.7.7,0,0,1,.58-.8h0a.69.69,0,0,1,.81.58l3.34,20.77A.7.7,0,0,1,120.06,313.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.75,312.09h0a.7.7,0,0,1-.8-.58l-3.34-20.78a.7.7,0,0,1,.58-.81h0a.7.7,0,0,1,.8.59l3.35,20.77A.71.71,0,0,1,129.75,312.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.08,280.12h0a.7.7,0,0,1,.81.58l3.34,20.78a.7.7,0,0,1-.58.8h0a.7.7,0,0,1-.8-.58l-3.35-20.78A.7.7,0,0,1,187.08,280.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,280.94h0a.7.7,0,0,1,.8.58l3.35,20.78a.7.7,0,0,1-.58.8h0a.69.69,0,0,1-.81-.58l-3.34-20.77A.7.7,0,0,1,182,280.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58,282.13h0a.7.7,0,0,1,.8.58l3.35,20.78a.7.7,0,0,1-.58.8h0a.7.7,0,0,1-.81-.58L174,282.94A.71.71,0,0,1,174.58,282.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.42,283.45h0a.7.7,0,0,1,.8.58l3.34,20.78a.69.69,0,0,1-.58.8h0a.7.7,0,0,1-.8-.58l-3.34-20.78A.69.69,0,0,1,166.42,283.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.49,284.89h0a.69.69,0,0,1,.8.58l3.35,20.77a.7.7,0,0,1-.58.81h0a.7.7,0,0,1-.81-.58l-3.34-20.78A.7.7,0,0,1,157.49,284.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,286.45h0a.69.69,0,0,1,.8.58l3.34,20.77a.69.69,0,0,1-.58.81h0a.7.7,0,0,1-.8-.58l-3.34-20.78A.69.69,0,0,1,147.8,286.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.18,280.46l3.33,20.64a2.28,2.28,0,0,1-1.88,2.59L90,320.06a2.27,2.27,0,0,1-2.37-1.19l55.63-9-3.57-22.15,9.37-1.51,3.57,22.16,2.72-.44-3.57-22.16,7-1.12,3.56,22.16.91-.15-3.56-22.16,7.4-1.19,3.57,22.16.6-.1-3.56-22.15,22.26-3.59A2.13,2.13,0,0,1,190.18,280.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.59,278.59,85.94,295a2.26,2.26,0,0,0-1.88,2.59l3.33,20.63a2.23,2.23,0,0,0,.22.69l2.19-.35-3.57-22.16,1.28-.21,3.57,22.16,3.18-.51-3.57-22.16,2-.32,3.57,22.16,5.25-.85L98,294.48l2.86-.47,3.57,22.16,4.39-.71-3.57-22.15,3.06-.49L111.83,315l4.38-.71-3.56-22.15,4.76-.77L121,313.5l2.2-.35L119.6,291l7.25-1.17L130.42,312l1.1-.18L128,289.64l62-10A2.27,2.27,0,0,0,187.59,278.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,311.66,90.55,320a2.84,2.84,0,0,1-3.26-2.35L85.41,306C115.2,294.32,134.4,305.4,142.13,311.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,342.66,77.43,409l-6,6.06a2.82,2.82,0,0,1-4,0l-14-13.88a2.83,2.83,0,0,1,0-4L71,379.37l54-54.57a2.84,2.84,0,0,1,4,0l14,13.88A2.84,2.84,0,0,1,143,342.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.13,377.78h0a.7.7,0,0,1-1,0l-15-14.8a.7.7,0,0,1,0-1h0a.71.71,0,0,1,1,0l15,14.79A.7.7,0,0,1,106.13,377.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.46,413.87h0a.7.7,0,0,1-1,0l-15-14.79a.7.7,0,0,1,0-1h0a.7.7,0,0,1,1,0l15,14.8A.71.71,0,0,1,70.46,413.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,410.19h0a.7.7,0,0,1-1,0l-15-14.79a.7.7,0,0,1,0-1h0a.7.7,0,0,1,1,0l15,14.8A.7.7,0,0,1,74.1,410.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.37,404.86h0a.71.71,0,0,1-1,0l-15-14.79a.7.7,0,0,1,0-1h0a.7.7,0,0,1,1,0l15,14.8A.7.7,0,0,1,79.37,404.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.18,399h0a.7.7,0,0,1-1,0l-15-14.79a.7.7,0,0,1,0-1h0a.7.7,0,0,1,1,0l15,14.8A.7.7,0,0,1,85.18,399Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.53,392.55h0a.71.71,0,0,1-1,0l-15-14.79a.7.7,0,0,1,0-1h0a.7.7,0,0,1,1,0l15,14.8A.7.7,0,0,1,91.53,392.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,385.56h0a.71.71,0,0,1-1,0l-15-14.79a.7.7,0,0,1,0-1h0a.7.7,0,0,1,1,0l15,14.79A.7.7,0,0,1,98.44,385.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83,325.92h0a.7.7,0,0,1,1,0l15,14.79a.7.7,0,0,1,0,1h0a.7.7,0,0,1-1,0l-15-14.79A.7.7,0,0,1,125.83,325.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,329.59h0a.71.71,0,0,1,1,0l15,14.79a.7.7,0,0,1,0,1h0a.7.7,0,0,1-1,0l-15-14.79A.71.71,0,0,1,122.2,329.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.93,334.92h0a.71.71,0,0,1,1,0l15,14.79a.71.71,0,0,1,0,1h0a.7.7,0,0,1-1,0l-15-14.79A.72.72,0,0,1,116.93,334.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,340.81h0a.7.7,0,0,1,1,0l15,14.79a.7.7,0,0,1,0,1h0a.7.7,0,0,1-1,0l-15-14.79A.7.7,0,0,1,111.12,340.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.76,347.24h0a.7.7,0,0,1,1,0l15,14.79a.71.71,0,0,1,0,1h0a.71.71,0,0,1-1,0l-15-14.79A.71.71,0,0,1,104.76,347.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.86,354.22h0a.7.7,0,0,1,1,0l15,14.8a.71.71,0,0,1,0,1h0a.7.7,0,0,1-1,0l-15-14.79A.71.71,0,0,1,97.86,354.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.54,324.36l14.86,14.7a2.25,2.25,0,0,1,0,3.19L71,415.48a2.26,2.26,0,0,1-2.61.44L108,375.85l-16-15.78,6.68-6.75,16,15.78,1.93-2-16-15.78,5-5,16,15.78.64-.65-16-15.78,5.28-5.34,16,15.78.43-.44-16-15.77,15.85-16A2.46,2.46,0,0,1,128.54,324.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.34,324.38,53,397.61a2.25,2.25,0,0,0,0,3.2L67.84,415.5a2.13,2.13,0,0,0,.59.42L70,414.35,54,398.57l.92-.93,16,15.78,2.26-2.28-16-15.78,1.43-1.45,16,15.78,3.74-3.78-16-15.78,2-2.06,16,15.77,3.12-3.16-16-15.77,2.18-2.21,16,15.78,3.12-3.16-16-15.78,3.39-3.43,16,15.78,1.57-1.58-16-15.78L83,369.31l16,15.77.78-.79-16-15.78,44.11-44.62A2.25,2.25,0,0,0,125.34,324.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,342.66,77.43,409A92.76,92.76,0,0,1,71,379.37l54-54.57a2.84,2.84,0,0,1,4,0l14,13.88A2.84,2.84,0,0,1,143,342.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,391.08h-2s.14,16.23-3.92,24.84l-1.24.23H146a2.84,2.84,0,0,1-2.85-2.83V393.58a2.85,2.85,0,0,1,2.85-2.85h1.26a2.84,2.84,0,0,1-1.62-2.56V368.43a2.85,2.85,0,0,1,1.62-2.56h-7.88a2.82,2.82,0,0,1-2.83-2.83V343.29a2.82,2.82,0,0,1,2.83-2.83h5.4a2.87,2.87,0,0,1-1.63-2.56V318.15a2.85,2.85,0,0,1,2.85-2.84h7.11s22.55,9.28,31.74,25.51h-4.81s9.21,12.12,8.8,24.77H193A55.77,55.77,0,0,1,193,391.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69,361.81c0,.24,0,.47,0,.71,0,.68,0,1.36,0,2a72.43,72.43,0,0,1-.69,7.61c-.07.48-.14.95-.22,1.42l-.09.57c-.17.94-.34,1.87-.55,2.79-.37,1.76-.82,3.47-1.33,5.15-.15.48-.29,1-.45,1.42l-.18.55c-.1.31-.21.62-.32.93a60.22,60.22,0,0,1-2.6,6.25c-.22.45-.44.9-.67,1.34l0,.07c-.09.19-.18.36-.28.54a52.82,52.82,0,0,1-4,6.41c-.34.49-.71,1-1.06,1.42a45.18,45.18,0,0,1-5.77,6.15c-.56.5-1.12,1-1.7,1.43a37.56,37.56,0,0,1-5.85,3.81c-1,.52-2,1-3,1.42a31.33,31.33,0,0,1-25.19-.67,0,0,0,0,1,0,0c-15.92-7.38-27.35-27.58-27.35-51.34s11.43-44,27.35-51.35h0a30,30,0,0,1,3.65-1.43,30.76,30.76,0,0,1,9.71-1.57,31.39,31.39,0,0,1,11.81,2.33l.07,0a29,29,0,0,1,2.84,1.31l.15.07a37.11,37.11,0,0,1,5,3.18l.83.64c.57.45,1.13.92,1.69,1.41h0a46.92,46.92,0,0,1,5.15,5.37l.62.79c.36.46.72.93,1.07,1.42.18.24.35.48.51.73,1,1.43,1.95,2.93,2.84,4.5.31.56.62,1.13.91,1.71s.48.94.71,1.42q1.06,2.17,2,4.49c.41,1.06.79,2.14,1.15,3.23l.45,1.42.06.23q.33,1.11.63,2.25c.51,1.95.94,4,1.28,6,.08.46.15.93.21,1.39v0c.05.37.1.74.14,1.11a68.43,68.43,0,0,1,.59,8.55C167.69,361.33,167.69,361.58,167.69,361.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69,361.81c0,.24,0,.47,0,.71,0,.68,0,1.36,0,2a72.43,72.43,0,0,1-.69,7.61c-.07.48-.14.95-.22,1.42l-.09.57c-.17.94-.34,1.87-.55,2.79-.37,1.76-.82,3.47-1.33,5.15-.15.48-.29,1-.45,1.42l-.18.55c-.1.31-.21.62-.32.93a60.22,60.22,0,0,1-2.6,6.25c-.22.45-.44.9-.67,1.34l0,.07c-.09.19-.18.36-.28.54a52.82,52.82,0,0,1-4,6.41c-.34.49-.71,1-1.06,1.42a45.18,45.18,0,0,1-5.77,6.15c-.56.5-1.12,1-1.7,1.43a37.56,37.56,0,0,1-5.85,3.81c-1,.52-2,1-3,1.42A31.48,31.48,0,0,1,127,416.15h-10.9a2.46,2.46,0,0,1-2.41-2,2.54,2.54,0,0,1,0-.49V309.92a2.73,2.73,0,0,1,0-.5s0,0,0-.05a2.47,2.47,0,0,1,2.4-1.91H127a31.39,31.39,0,0,1,11.81,2.33l.07,0a29,29,0,0,1,2.84,1.31l.15.07a37.11,37.11,0,0,1,5,3.18l.83.64c.57.45,1.13.92,1.69,1.41h0a46.92,46.92,0,0,1,5.15,5.37l.62.79c.36.46.72.93,1.07,1.42.18.24.35.48.51.73,1,1.43,1.95,2.93,2.84,4.5.31.56.62,1.13.91,1.71s.48.94.71,1.42q1.06,2.17,2,4.49c.41,1.06.79,2.14,1.15,3.23l.45,1.42.06.23q.33,1.11.63,2.25c.51,1.95.94,4,1.28,6,.08.46.15.93.21,1.39v0c.05.37.1.74.14,1.11a68.43,68.43,0,0,1,.59,8.55C167.69,361.33,167.69,361.58,167.69,361.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69,361.81c0,.24,0,.47,0,.71H118a.71.71,0,1,1,0-1.42h49.71C167.69,361.33,167.69,361.58,167.69,361.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,311.2H118a.71.71,0,0,1-.32-.07.7.7,0,0,1-.39-.63.68.68,0,0,1,.54-.68.51.51,0,0,1,.17,0h20.81l.07,0a29,29,0,0,1,2.84,1.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.38,316.43H118a.7.7,0,0,1-.71-.7A.71.71,0,0,1,118,315h29.72C148.26,315.47,148.82,315.94,149.38,316.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23,324H118a.71.71,0,1,1,0-1.42h37.19C155.52,323.06,155.88,323.53,156.23,324Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.2,332.38H118a.71.71,0,0,1,0-1.42h42.52C160.74,331.42,161,331.9,161.2,332.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,341.52H118a.71.71,0,0,1,0-1.42h46.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,351.44H118a.5.5,0,0,1-.17,0,.7.7,0,0,1-.54-.68A.71.71,0,0,1,118,350h48.76c.08.46.15.93.21,1.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,412.41c-1,.52-2,1-3,1.42H118a.71.71,0,0,1,0-1.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.4,407.17c-.56.5-1.12,1-1.7,1.43H118a.72.72,0,0,1,0-1.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23,399.6c-.34.49-.71,1-1.06,1.42H118a.71.71,0,1,1,0-1.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.21,391.24c-.22.45-.44.9-.67,1.34l0,.07H118a.71.71,0,1,1,0-1.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,382.09c-.15.48-.29,1-.45,1.42H118a.71.71,0,0,1,0-1.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,372.16c-.07.48-.14.95-.22,1.42H118a.71.71,0,1,1,0-1.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,309.82v-2.24a11.35,11.35,0,0,1,1.68-.12h8a31.39,31.39,0,0,1,11.81,2.33l.07,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,314.38h-29.6v-3.25h24.43l.15.07A37.11,37.11,0,0,1,146.86,314.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.54,321.81H117.26v-5.37h32.13A46.92,46.92,0,0,1,154.54,321.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,329.25H117.26v-4.5h39.48C157.75,326.18,158.69,327.68,159.58,329.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.16,336.87h-45.9v-4.49H161.2Q162.26,334.55,163.16,336.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.45,344H117.26v-2.25h47.56Q165.15,342.86,165.45,344Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.09,352.55H117.26v-1.13h49.68v0C167,351.81,167.05,352.18,167.09,352.55Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.44,367.79l.06-.8c.06-.77.1-1.54.13-2.32a.17.17,0,0,0,0-.07v-.05h0c0-.9.05-1.82.05-2.74,0-30-18.23-54.35-40.72-54.35-.28,0-.56,0-.84,0,22.1.59,39.88,24.7,39.88,54.33,0,.92,0,1.84,0,2.74h-48.7v-57c-1.85.26-3.26.94-3.59,1.79,0,0,0,0,0,.05a1,1,0,0,0-.06.33V413.87a.87.87,0,0,0,.06.32c.37,1.11,2.6,2,5.28,2h8c.63,0,1.25,0,1.88-.06l.55,0c.46,0,.93-.08,1.39-.14l.51-.07q.91-.12,1.8-.3l.35-.08c.49-.1,1-.22,1.46-.35l.56-.15c.46-.13.92-.27,1.37-.42l.41-.14c.52-.18,1-.37,1.55-.57l.15-.07.55-.24q.6-.25,1.2-.54l.59-.29.56-.28c.22-.11.43-.24.65-.36l.53-.29c.42-.24.83-.49,1.25-.75.14-.1.29-.19.44-.28.54-.35,1.07-.71,1.59-1.09.18-.12.34-.26.51-.38l.88-.66.14-.12,1.16-1,.4-.34.11-.1.84-.77.79-.75.63-.65.91-.95.54-.61c.31-.35.63-.71.93-1.07l.47-.57.55-.68.4-.54.42-.56.24-.32.53-.75.44-.63c.4-.59.8-1.2,1.18-1.82l.08-.13q.54-.88,1-1.8c.08-.13.15-.26.22-.39.17-.29.33-.59.49-.89h0l.32-.61h0a.31.31,0,0,1,.05-.1l.32-.65.3-.59c.07-.14.13-.29.19-.43.34-.71.66-1.43,1-2.16l.29-.65c.39-1,.77-1.95,1.12-2.94l0-.07h0c.11-.3.21-.62.32-.93h0l.18-.55c0-.08.05-.16.08-.24.08-.24.15-.49.23-.73s.09-.3.14-.45.11-.39.16-.59c.15-.5.29-1,.43-1.5s.19-.75.28-1.13c.14-.56.27-1.13.4-1.7l.06-.23h0q.3-1.38.54-2.79h0l.09-.57.09-.56c0-.17.05-.34.08-.51s0-.23,0-.35c.1-.65.18-1.3.26-2,0-.17,0-.35,0-.52C167.33,369.05,167.39,368.43,167.44,367.79Zm-8.91,25.4H117.26v-.61h41.59Zm3.6-8.2H117.26v-.93h45.18C162.33,384.37,162.24,384.69,162.13,385Zm2.27-8.05H117.26v-2.79h47.68Q164.7,375.56,164.4,376.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.76,361.81c0,30-18.23,54.35-40.72,54.35s-40.72-24.33-40.72-54.35S93.55,307.46,116,307.46,156.76,331.8,156.76,361.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.04,
    cy: 361.81,
    rx: 34.18,
    ry: 45.62,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.55,348.6h0c-4.42-23.63-20.43-41.13-39.5-41.13-22.5,0-40.73,24.34-40.73,54.35a68.38,68.38,0,0,0,5.42,27.09c7,16.29,20.21,27.25,35.31,27.25,22.48,0,40.72-24.33,40.72-54.34A71.08,71.08,0,0,0,155.55,348.6Zm-39.5,65.73c-13.45,0-25.31-9-32.41-22.71a65,65,0,0,1-7-29.81c0-29,17.61-52.52,39.36-52.52,19.54,0,35.76,19,38.82,43.95a68.83,68.83,0,0,1,.53,8.57C155.4,390.82,137.78,414.33,116.05,414.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94,342.29c-5.7-14.6-17.14-24.55-30.32-24.55-18.88,0-34.18,20.43-34.18,45.62a58.45,58.45,0,0,0,3.29,19.56,57.84,57.84,0,0,1-3.87-21.11c0-25.19,15.3-45.62,34.18-45.62C129.68,316.19,141.46,326.86,146.94,342.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.77,361.81c0,30-18.24,54.34-40.72,54.34-15.1,0-28.28-11-35.31-27.25.88.88,1.85,1.79,2.9,2.72,7.1,13.72,19,22.71,32.41,22.71,21.73,0,39.35-23.51,39.35-52.52a68.83,68.83,0,0,0-.53-8.57c.27-1.64.49-3.2.68-4.64A71.08,71.08,0,0,1,156.77,361.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119,386.44v7.46H114.9l-1.16-1.54,1.16-5.85c-4.9-.4-10.8-4.08-13.4-7.08l3.41-5.19a16.74,16.74,0,0,0,10,5.07V366c-3.31-1.07-9.5-4.17-11.05-8.06a23.73,23.73,0,0,1-.44-5.4c0-6.8,3.7-12.73,11.49-13.73l2.93-9.08,1.16,1.55v7.4c3.42.24,9,2.51,9,2.51l1.16,1.55-2,6.73a17.42,17.42,0,0,0-8.09-3.6v13.47a56.36,56.36,0,0,1,7.81,3.48,15.72,15.72,0,0,1,3.78,9.91C130.58,379.51,126.83,385.37,119,386.44Zm-4.09-28.52V346.05a5.8,5.8,0,0,0-5.05,6.07C109.85,355.32,112,356.78,114.9,357.92Zm9.29,15.39c0-3.26-2.2-4.8-5.2-5.93v11.8C122.64,378.44,124.19,376.18,124.19,373.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,384.89v7.47h-4.09V385c-4.9-.4-9.64-2.53-12.24-5.53l2.25-6.73a16.78,16.78,0,0,0,10,5.06V364.43c-5.54-1.8-11.49-4.2-11.49-13.46,0-6.8,3.7-12.73,11.49-13.73v-7.53h4.09v7.4A17.77,17.77,0,0,1,128,341.17l-2,6.73a17.4,17.4,0,0,0-8.09-3.59v13.46c5.55,1.8,11.59,4.13,11.59,13.39C129.42,378,125.67,383.83,117.83,384.89Zm-4.09-28.52V344.51a5.78,5.78,0,0,0-5,6.06C108.69,353.77,110.84,355.24,113.74,356.37ZM123,371.76c0-3.26-2.2-4.8-5.2-5.93v11.8C121.48,376.89,123,374.63,123,371.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.76,361.81c0,18.82-7.17,35.42-18.08,45.17L79.12,338.89c6.47-18.56,20.57-31.43,36.92-31.43C138.53,307.46,156.76,331.8,156.76,361.81Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.59,
    y: 200.37,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    transform: "translate(61.2 -58.3) rotate(14.4)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.55,223.9h0A.71.71,0,0,1,258,223l5.24-20.38a.7.7,0,0,1,.85-.51h0a.71.71,0,0,1,.51.86l-5.24,20.38A.7.7,0,0,1,258.55,223.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,211.28h0a.71.71,0,0,1-.5-.86L214.13,190a.71.71,0,0,1,.86-.5h0a.69.69,0,0,1,.5.85l-5.23,20.38A.71.71,0,0,1,209.4,211.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.41,212.56h0a.69.69,0,0,1-.5-.85l5.23-20.38a.71.71,0,0,1,.86-.51h0a.71.71,0,0,1,.5.86l-5.23,20.38A.71.71,0,0,1,214.41,212.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.67,214.43h0a.71.71,0,0,1-.5-.86l5.23-20.38a.71.71,0,0,1,.86-.5h0a.69.69,0,0,1,.5.85l-5.23,20.38A.71.71,0,0,1,221.67,214.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.68,216.48h0a.69.69,0,0,1-.5-.85l5.23-20.38a.71.71,0,0,1,.85-.51h0a.7.7,0,0,1,.51.86L230.54,216A.71.71,0,0,1,229.68,216.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.44,218.73h0a.7.7,0,0,1-.5-.85l5.23-20.38A.71.71,0,0,1,244,197h0a.71.71,0,0,1,.51.85l-5.24,20.39A.69.69,0,0,1,238.44,218.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,221.17h0a.7.7,0,0,1-.51-.85l5.24-20.38a.7.7,0,0,1,.85-.51h0a.71.71,0,0,1,.51.86l-5.24,20.38A.7.7,0,0,1,248,221.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.28,214.77h0a.71.71,0,0,1,.5.86L308.55,236a.7.7,0,0,1-.86.5h0a.69.69,0,0,1-.5-.85l5.23-20.38A.71.71,0,0,1,313.28,214.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,213.49h0a.7.7,0,0,1,.5.85l-5.23,20.38a.7.7,0,0,1-.86.51h0a.7.7,0,0,1-.5-.85L307.41,214A.71.71,0,0,1,308.27,213.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,211.62h0a.71.71,0,0,1,.5.86l-5.23,20.38a.69.69,0,0,1-.85.5h0a.69.69,0,0,1-.5-.85l5.23-20.38A.71.71,0,0,1,301,211.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,209.57h0a.7.7,0,0,1,.5.85l-5.23,20.38a.71.71,0,0,1-.85.51h0a.71.71,0,0,1-.51-.85l5.24-20.39A.69.69,0,0,1,293,209.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.24,207.32h0a.69.69,0,0,1,.5.85l-5.23,20.38a.7.7,0,0,1-.85.51h0a.71.71,0,0,1-.51-.85l5.24-20.39A.7.7,0,0,1,284.24,207.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,204.88h0a.7.7,0,0,1,.51.85L270,226.11a.7.7,0,0,1-.85.51h0a.71.71,0,0,1-.51-.86l5.24-20.38A.7.7,0,0,1,274.73,204.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,216.33l-5.2,20.24A2.26,2.26,0,0,1,308,238.2L208.3,212.59a2.25,2.25,0,0,1-1.69-2l54.57,14,5.58-21.74,9.19,2.36-5.58,21.74,2.67.69,5.58-21.74,6.82,1.75-5.58,21.74.89.23,5.59-21.74,7.26,1.87L288,231.46l.59.15,5.58-21.73L316,215.49A2.42,2.42,0,0,1,316,216.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.35,213.58,214.62,188a2.25,2.25,0,0,0-2.75,1.62l-5.2,20.25a2.2,2.2,0,0,0-.06.72l2.14.55,5.58-21.74,1.26.32L210,211.43l3.11.8,5.58-21.74,2,.51-5.58,21.74,5.15,1.32,5.58-21.74,2.81.73-5.58,21.73,4.3,1.11,5.58-21.74,3,.77-5.58,21.74,4.3,1.1L240.25,196l4.67,1.2L239.34,219l2.15.55,5.58-21.73,7.11,1.82-5.58,21.74,1.08.28,5.58-21.74L316,215.49A2.27,2.27,0,0,0,314.35,213.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.73,
    y: 390.73,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.47,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,278.47,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73,414.61h0a.71.71,0,0,1-.7-.7V392.86a.71.71,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,227.73,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.91,414.61h0a.71.71,0,0,1-.71-.7V392.86a.71.71,0,0,1,.71-.7h0a.71.71,0,0,1,.7.7v21.05A.71.71,0,0,1,232.91,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,240.4,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,248.67,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21.05A.7.7,0,0,1,257.71,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,414.61h0a.7.7,0,0,1-.7-.7V392.86a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21.05A.71.71,0,0,1,267.53,414.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.21,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,329.21,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,392.16h0a.71.71,0,0,1,.7.7v21.05a.71.71,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V392.86A.7.7,0,0,1,324,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.54,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.71.71,0,0,1-.7-.7V392.86A.71.71,0,0,1,316.54,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,392.16h0a.71.71,0,0,1,.71.7v21.05a.71.71,0,0,1-.71.7h0a.71.71,0,0,1-.7-.7V392.86A.71.71,0,0,1,308.27,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.23,392.16h0a.7.7,0,0,1,.7.7v21.05a.7.7,0,0,1-.7.7h0a.71.71,0,0,1-.7-.7V392.86A.71.71,0,0,1,299.23,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.42,392.16h0a.71.71,0,0,1,.7.7v21.05a.71.71,0,0,1-.7.7h0a.71.71,0,0,1-.71-.7V392.86A.71.71,0,0,1,289.42,392.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,393V413.9a2.26,2.26,0,0,1-2.26,2.26H227a2.27,2.27,0,0,1-2.15-1.55h56.34V392.17h9.5v22.44h2.75V392.17h7.05v22.44h.92V392.17h7.5v22.44h.61V392.17h22.55A2.21,2.21,0,0,1,332.21,393Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,390.73H227a2.26,2.26,0,0,0-2.26,2.26V413.9a2.45,2.45,0,0,0,.11.71h2.22V392.16h1.3v22.45h3.21V392.17h2v22.44h5.32V392.17h2.9v22.44h4.44V392.17h3.1v22.44h4.44V392.17h4.82v22.44h2.23V392.17h7.34v22.44h1.12V392.17h62.74A2.26,2.26,0,0,0,330,390.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.64,
    y: 365.27,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.38,389.14h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,269.38,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.64,389.14h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,218.64,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.81,389.14h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,223.81,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.31,389.14h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,231.31,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,389.14h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.71.7v21A.7.7,0,0,1,239.57,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,389.14h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,248.62,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,389.14h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,258.43,389.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.12,366.7h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,320.12,366.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.94,366.7h0a.7.7,0,0,1,.71.7v21a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,314.94,366.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,366.7h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,307.45,366.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.18,366.7h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,299.18,366.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,366.7h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,290.14,366.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.32,366.7h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,280.32,366.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.12,367.53v20.9a2.26,2.26,0,0,1-2.26,2.26h-103a2.27,2.27,0,0,1-2.15-1.55h56.34V366.7h9.49v22.44h2.76V366.7h7v22.44h.92V366.7h7.5v22.44h.62V366.7H323A2.31,2.31,0,0,1,323.12,367.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.86,365.27h-103a2.26,2.26,0,0,0-2.26,2.26v20.9a2.07,2.07,0,0,0,.11.71H218V366.7h1.3v22.44h3.22V366.7h2v22.44h5.32V366.7h2.91v22.44h4.44V366.7h3.09v22.44h4.45V366.7h4.82v22.44h2.22V366.7h7.35v22.44h1.11V366.7H323A2.28,2.28,0,0,0,320.86,365.27Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.56,
    y: 339.8,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,363.68h0a.7.7,0,0,1-.7-.7V341.93a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7V363A.7.7,0,0,1,279.3,363.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.56,363.68h0a.7.7,0,0,1-.7-.7V341.93a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7V363A.7.7,0,0,1,228.56,363.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.03,
    y: 341.23,
    width: 1.4,
    height: 22.45,
    rx: 0.7,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,363.68h0a.7.7,0,0,1-.7-.7V341.93a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7V363A.7.7,0,0,1,241.23,363.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.49,363.68h0a.7.7,0,0,1-.7-.7V341.93a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7V363A.7.7,0,0,1,249.49,363.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.54,363.68h0a.7.7,0,0,1-.7-.7V341.93a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7V363A.7.7,0,0,1,258.54,363.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.35,363.68h0a.7.7,0,0,1-.7-.7V341.93a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7V363A.7.7,0,0,1,268.35,363.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,341.23h0a.71.71,0,0,1,.7.7V363a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V341.93A.7.7,0,0,1,330,341.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,341.23h0a.71.71,0,0,1,.71.7V363a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7V341.93A.71.71,0,0,1,324.86,341.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,341.23h0a.7.7,0,0,1,.7.7V363a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V341.93A.7.7,0,0,1,317.37,341.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,341.23h0a.7.7,0,0,1,.7.7V363a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V341.93A.7.7,0,0,1,309.1,341.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.06,341.23h0a.7.7,0,0,1,.7.7V363a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V341.93A.7.7,0,0,1,300.06,341.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,341.23h0a.7.7,0,0,1,.7.7V363a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V341.93A.7.7,0,0,1,290.24,341.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,342.07V363a2.26,2.26,0,0,1-2.26,2.26h-103a2.27,2.27,0,0,1-2.15-1.55H282V341.24h9.49v22.44h2.76V341.24h7v22.44h.92V341.24h7.5v22.44h.62V341.24h22.55A2.23,2.23,0,0,1,333,342.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.78,339.81h-103a2.25,2.25,0,0,0-2.26,2.26V363a2.15,2.15,0,0,0,.11.71h2.21V341.23h1.3v22.45h3.22V341.24h2v22.44h5.32V341.24h2.91v22.44h4.44V341.24h3.1v22.44h4.44V341.24h4.82v22.44h2.22V341.24H269v22.44h1.11V341.24h62.75A2.27,2.27,0,0,0,330.78,339.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.56,
    y: 314.34,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,338.22h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,279.3,338.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.56,338.22h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,228.56,338.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.03,
    y: 315.77,
    width: 1.4,
    height: 22.45,
    rx: 0.7,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,338.22h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.71.71,0,0,1,241.23,338.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.49,338.22h0a.71.71,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.71.7v21A.71.71,0,0,1,249.49,338.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.54,338.22h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.71.71,0,0,1,258.54,338.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.35,338.22h0a.71.71,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.71.7v21A.71.71,0,0,1,268.35,338.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,315.77h0a.7.7,0,0,1,.7.7v21a.71.71,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,330,315.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,315.77h0a.7.7,0,0,1,.71.7v21a.71.71,0,0,1-.71.7h0a.71.71,0,0,1-.7-.7v-21A.7.7,0,0,1,324.86,315.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,315.77h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,317.37,315.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,315.77h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,309.1,315.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.06,315.77h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,300.06,315.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,315.77h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,290.24,315.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,316.6v20.9a2.26,2.26,0,0,1-2.26,2.26h-103a2.27,2.27,0,0,1-2.15-1.54H282V315.77h9.49v22.45h2.76V315.77h7v22.45h.92V315.77h7.5v22.45h.62V315.77h22.55A2.31,2.31,0,0,1,333,316.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.78,314.34h-103a2.26,2.26,0,0,0-2.26,2.26v20.9a2.17,2.17,0,0,0,.11.72h2.21V315.77h1.3v22.45h3.22V315.77h2v22.45h5.32V315.77h2.91v22.45h4.44V315.77h3.1v22.45h4.44V315.77h4.82v22.45h2.22V315.77H269v22.45h1.11V315.77h62.75A2.28,2.28,0,0,0,330.78,314.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.6,
    y: 288.88,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.34,312.75h0a.7.7,0,0,1-.7-.7V291a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,274.34,312.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.6,312.75h0a.7.7,0,0,1-.7-.7V291a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,223.6,312.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.77,312.75h0a.7.7,0,0,1-.7-.7V291a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,228.77,312.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.27,312.75h0a.7.7,0,0,1-.7-.7V291a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,236.27,312.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.53,312.75h0a.7.7,0,0,1-.7-.7V291a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.71.7v21A.7.7,0,0,1,244.53,312.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.58,312.75h0a.7.7,0,0,1-.7-.7V291a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,253.58,312.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,312.75h0a.7.7,0,0,1-.7-.7V291a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,263.39,312.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.08,290.31h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V291A.7.7,0,0,1,325.08,290.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,290.31h0a.7.7,0,0,1,.71.7v21a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7V291A.7.7,0,0,1,319.9,290.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.41,290.31h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V291A.7.7,0,0,1,312.41,290.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14,290.31h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V291A.7.7,0,0,1,304.14,290.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.1,290.31h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V291A.7.7,0,0,1,295.1,290.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.28,290.31h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7V291A.7.7,0,0,1,285.28,290.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,291.14V312a2.26,2.26,0,0,1-2.26,2.26h-103a2.27,2.27,0,0,1-2.15-1.55h56.34V290.31h9.49v22.44h2.76V290.31h7v22.44h.92V290.31h7.5v22.44h.62V290.31h22.55A2.27,2.27,0,0,1,328.08,291.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,288.88h-103a2.25,2.25,0,0,0-2.26,2.26V312a2.07,2.07,0,0,0,.11.71h2.21V290.31h1.3v22.44h3.22V290.31h2v22.44h5.32V290.31h2.91v22.44h4.44V290.31h3.1v22.44h4.44V290.31h4.82v22.44h2.22V290.31h7.35v22.44h1.11V290.31h62.75A2.28,2.28,0,0,0,325.82,288.88Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.56,
    y: 263.41,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,287.29h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,279.3,287.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.56,287.29h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,228.56,287.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.03,
    y: 264.84,
    width: 1.4,
    height: 22.45,
    rx: 0.7,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,287.29h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21A.7.7,0,0,1,241.23,287.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.49,287.29h0a.7.7,0,0,1-.7-.7v-21a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7v21A.7.7,0,0,1,249.49,287.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.54,287.29h0a.7.7,0,0,1-.7-.7v-21a.7.7,0,0,1,.7-.7h0a.71.71,0,0,1,.7.7v21A.7.7,0,0,1,258.54,287.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.35,287.29h0a.7.7,0,0,1-.7-.7v-21a.71.71,0,0,1,.7-.7h0a.71.71,0,0,1,.71.7v21A.7.7,0,0,1,268.35,287.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,264.84h0a.71.71,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,330,264.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.86,264.84h0a.71.71,0,0,1,.71.7v21a.7.7,0,0,1-.71.7h0a.7.7,0,0,1-.7-.7v-21A.71.71,0,0,1,324.86,264.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,264.84h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,317.37,264.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,264.84h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,309.1,264.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.06,264.84h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,300.06,264.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,264.84h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.7h0a.7.7,0,0,1-.7-.7v-21A.7.7,0,0,1,290.24,264.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,265.67v20.91a2.26,2.26,0,0,1-2.26,2.26h-103a2.27,2.27,0,0,1-2.15-1.55H282V264.85h9.49v22.44h2.76V264.85h7v22.44h.92V264.85h7.5v22.44h.62V264.85h22.55A2.21,2.21,0,0,1,333,265.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.78,263.41h-103a2.26,2.26,0,0,0-2.26,2.26v20.91a2.15,2.15,0,0,0,.11.71h2.21V264.84h1.3v22.45h3.22V264.85h2v22.44h5.32V264.85h2.91v22.44h4.44V264.85h3.1v22.44h4.44V264.85h4.82v22.44h2.22V264.85H269v22.44h1.11V264.85h62.75A2.28,2.28,0,0,0,330.78,263.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.6,
    y: 237.95,
    width: 107.48,
    height: 25.42,
    rx: 2.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.34,261.83h0a.7.7,0,0,1-.7-.71v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,274.34,261.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.6,261.83h0a.7.7,0,0,1-.7-.71v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,223.6,261.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.77,261.83h0a.7.7,0,0,1-.7-.71v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,228.77,261.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.27,261.83h0a.7.7,0,0,1-.7-.71v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.71.71,0,0,1,236.27,261.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.53,261.83h0a.71.71,0,0,1-.7-.71v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.71.7v21A.71.71,0,0,1,244.53,261.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.58,261.83h0a.7.7,0,0,1-.7-.71v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.71.71,0,0,1,253.58,261.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,261.83h0a.71.71,0,0,1-.7-.71v-21a.7.7,0,0,1,.7-.7h0a.7.7,0,0,1,.7.7v21A.7.7,0,0,1,263.39,261.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.08,239.38h0a.7.7,0,0,1,.7.7v21a.71.71,0,0,1-.7.71h0a.7.7,0,0,1-.7-.71v-21A.7.7,0,0,1,325.08,239.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,239.38h0a.7.7,0,0,1,.71.7v21a.71.71,0,0,1-.71.71h0a.71.71,0,0,1-.7-.71v-21A.7.7,0,0,1,319.9,239.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.41,239.38h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.71h0a.7.7,0,0,1-.7-.71v-21A.7.7,0,0,1,312.41,239.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14,239.38h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.71h0a.7.7,0,0,1-.7-.71v-21A.7.7,0,0,1,304.14,239.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.1,239.38h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.71h0a.7.7,0,0,1-.7-.71v-21A.7.7,0,0,1,295.1,239.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.28,239.38h0a.7.7,0,0,1,.7.7v21a.7.7,0,0,1-.7.71h0a.7.7,0,0,1-.7-.71v-21A.7.7,0,0,1,285.28,239.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,240.21v20.9a2.26,2.26,0,0,1-2.26,2.26h-103a2.27,2.27,0,0,1-2.15-1.55h56.34V239.38h9.49v22.44h2.76V239.38h7v22.44h.92V239.38h7.5v22.44h.62V239.38h22.55A2.31,2.31,0,0,1,328.08,240.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,238h-103a2.26,2.26,0,0,0-2.26,2.26v20.9a2.07,2.07,0,0,0,.11.71h2.21V239.38h1.3v22.44h3.22V239.38h2v22.44h5.32V239.38h2.91v22.44h4.44V239.38h3.1v22.44h4.44V239.38h4.82v22.44h2.22V239.38h7.35v22.44h1.11V239.38h62.75A2.28,2.28,0,0,0,325.82,238Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,314.34h2.91l-4.3.36A2.82,2.82,0,0,1,228.4,314.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.28,222.08l-36.41-9.35a2.84,2.84,0,0,1-2.05-3.45l1.51-5.88a52.78,52.78,0,0,1,14,2.52C234.28,209.61,241.26,216.21,245.28,222.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.43,288.87h27.29c-.4.87-6.94,14.83-18.71,25.41l-.24,0h-8.34a2.84,2.84,0,0,1-2.83-2.84V291.71A2.84,2.84,0,0,1,223.43,288.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,263.42h35.31c-.27,1.11-4.34,17.54-10.83,25.41H228.4a2.85,2.85,0,0,1-2.85-2.84V266.25A2.84,2.84,0,0,1,228.4,263.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,263.36H223.43a2.84,2.84,0,0,1-2.83-2.84V240.78a2.83,2.83,0,0,1,2.83-2.83h40.19C263.9,243.92,263.82,255.22,260,263.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.28,390.68H226.66c15.42-5.88,38.25-15.35,54.79-25.41h38.83a2.83,2.83,0,0,1,2.83,2.84v19.74A2.82,2.82,0,0,1,320.28,390.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.21,393.58v16.05c-10-4.86-14.84-10.66-14.84-10.66s-21.68,17.15-55.09,17.15a81.55,81.55,0,0,1-37.55-9V393.58a2.84,2.84,0,0,1,2.84-2.85h101.8A2.84,2.84,0,0,1,332.21,393.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,317.18v19.74a2.84,2.84,0,0,1-2.84,2.84H303.05c4-18.51,14.32-24.85,14.32-24.85H330.8l1.48.35A2.76,2.76,0,0,1,333,317.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,342.64v19.75a2.85,2.85,0,0,1-2.84,2.84H281.51c11.41-7,19.82-14.19,20.71-20.73.23-1.64.5-3.21.82-4.7H330.2A2.85,2.85,0,0,1,333,342.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57,283.73c-.11.2-.22.41-.34.61-.31.59-.64,1.17-1,1.74a73.3,73.3,0,0,1-4.12,6.29c-.28.38-.56.76-.85,1.13L235,294c-.58.73-1.16,1.46-1.77,2.16q-1.69,2-3.54,3.86c-.34.35-.68.69-1,1l-.41.39-.71.66a60.81,60.81,0,0,1-5.14,4.22c-.4.29-.8.58-1.21.85l-.06.05-.49.33a51.63,51.63,0,0,1-6.43,3.72c-.52.26-1.05.5-1.57.74a45,45,0,0,1-7.86,2.67c-.71.18-1.42.32-2.13.45a37,37,0,0,1-6.84.61,32.84,32.84,0,0,1-3.3-.19,30.82,30.82,0,0,1-11.34-3.44,31.21,31.21,0,0,1-10.21-8.78s0,0,0,0c-10.41-13.77-11-36.58,0-57.19s30.24-32.87,47.47-31.91h0a30.64,30.64,0,0,1,22.15,11.05l.05.06a30.31,30.31,0,0,1,1.86,2.45l.09.13a36,36,0,0,1,2.88,5.08c.15.3.29.62.43.94.29.65.56,1.32.82,2h0a45,45,0,0,1,2,7l.18,1c.1.57.18,1.14.27,1.72,0,.3.08.59.1.88a49.3,49.3,0,0,1,.38,5.21c0,.63,0,1.27,0,1.91s0,1,0,1.55c-.06,1.59-.18,3.19-.38,4.81-.13,1.11-.3,2.22-.49,3.34-.09.48-.17.95-.27,1.44a1.74,1.74,0,0,1-.05.22c-.15.75-.31,1.49-.49,2.24-.47,1.94-1,3.89-1.68,5.83-.14.43-.3.87-.46,1.3,0,0,0,0,0,0-.13.34-.25.68-.39,1a69.66,69.66,0,0,1-3.44,7.69C241.79,283.31,241.68,283.52,241.57,283.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57,283.73c-.11.2-.22.41-.34.61-.31.59-.64,1.17-1,1.74a73.3,73.3,0,0,1-4.12,6.29c-.28.38-.56.76-.85,1.13L235,294c-.58.73-1.16,1.46-1.77,2.16q-1.69,2-3.54,3.86c-.34.35-.68.69-1,1l-.41.39-.71.66a60.81,60.81,0,0,1-5.14,4.22c-.4.29-.8.58-1.21.85l-.06.05-.49.33a51.63,51.63,0,0,1-6.43,3.72c-.52.26-1.05.5-1.57.74a45,45,0,0,1-7.86,2.67c-.71.18-1.42.32-2.13.45a37,37,0,0,1-6.84.61,32.84,32.84,0,0,1-3.3-.19,30.82,30.82,0,0,1-11.34-3.44L171.65,307a2.4,2.4,0,0,1-1.18-2.81,1.92,1.92,0,0,1,.18-.45l48-90.05a2.42,2.42,0,0,1,.27-.41l0,0a2.43,2.43,0,0,1,3-.55l9.46,5a30.71,30.71,0,0,1,9.17,7.48l.05.06a30.31,30.31,0,0,1,1.86,2.45l.09.13a36,36,0,0,1,2.88,5.08c.15.3.29.62.43.94.29.65.56,1.32.82,2h0a45,45,0,0,1,2,7l.18,1c.1.57.18,1.14.27,1.72,0,.3.08.59.1.88a49.3,49.3,0,0,1,.38,5.21c0,.63,0,1.27,0,1.91s0,1,0,1.55c-.06,1.59-.18,3.19-.38,4.81-.13,1.11-.3,2.22-.49,3.34-.09.48-.17.95-.27,1.44a1.74,1.74,0,0,1-.05.22c-.15.75-.31,1.49-.49,2.24-.47,1.94-1,3.89-1.68,5.83-.14.43-.3.87-.46,1.3,0,0,0,0,0,0-.13.34-.25.68-.39,1a69.66,69.66,0,0,1-3.44,7.69C241.79,283.31,241.68,283.52,241.57,283.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57,283.73c-.11.2-.22.41-.34.61l-43.14-23a.7.7,0,0,1,.66-1.23l43.14,23C241.79,283.31,241.68,283.52,241.57,283.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,227.86l-20.71-11a.68.68,0,0,1-.24-.2.69.69,0,0,1-.05-.73.68.68,0,0,1,.78-.35.76.76,0,0,1,.16.06l18.06,9.62.05.06a30.31,30.31,0,0,1,1.86,2.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.66,235.89,219.4,221.36a.69.69,0,0,1-.29-.94.7.7,0,0,1,.94-.28l25.79,13.74C246.13,234.53,246.4,235.2,246.66,235.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,245.63l-33.21-17.69a.7.7,0,0,1,.66-1.23l32.28,17.2C248.93,244.48,249,245.05,249.1,245.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.54,255.18,212,235.2a.7.7,0,0,1-.29-.94.69.69,0,0,1,.94-.29l36.9,19.66C249.58,254.15,249.57,254.66,249.54,255.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4,264.77l-40.6-21.64a.68.68,0,0,1-.28-.94.69.69,0,0,1,.94-.29l40.21,21.43C248.58,263.81,248.5,264.28,248.4,264.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.72,274.39l-42.51-22.65a.31.31,0,0,1-.13-.1.69.69,0,0,1-.16-.84.7.7,0,0,1,.94-.28l42.32,22.54c-.14.43-.3.87-.46,1.3C245.73,274.38,245.72,274.38,245.72,274.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.75,315.69a32.84,32.84,0,0,1-3.3-.19l-18.08-9.63a.7.7,0,0,1-.28-.94.69.69,0,0,1,.94-.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.72,314.63c-.71.18-1.42.32-2.13.45l-25.8-13.75a.69.69,0,0,1-.29-.94.71.71,0,0,1,.95-.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.15,311.22c-.52.26-1.05.5-1.57.74l-32.29-17.2a.71.71,0,0,1-.28-.95.7.7,0,0,1,.94-.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.34,306.27c-.4.29-.8.58-1.21.85l-.06.05L184.16,287.5a.58.58,0,0,1-.23-.21.69.69,0,0,1-.06-.73.71.71,0,0,1,.94-.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,300c-.34.35-.68.69-1,1l-40.21-21.43a.7.7,0,1,1,.65-1.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,292.37c-.28.38-.56.76-.85,1.13L193,271a.7.7,0,1,1,.65-1.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.84,215.29l1-1.94a11.15,11.15,0,0,1,1.51.68l7,3.71a30.71,30.71,0,0,1,9.17,7.48l.05.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.41,232.94l-25.68-13.68,1.51-2.83,21.2,11.3.09.13A36,36,0,0,1,245.41,232.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.65,242.94,216.3,225.71l2.48-4.67,27.88,14.86A45,45,0,0,1,248.65,242.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.58,251.72l-36.72-19.56,2.08-3.91,34.26,18.26A49.3,49.3,0,0,1,249.58,251.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.16,260l-39.82-21.22,2.07-3.9,38.13,20.31C249.48,256.77,249.36,258.37,249.16,260Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.86,267.23,206,245l1-1.95,41.27,22C248.2,265.74,248,266.48,247.86,267.23Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.33,275.41l-43.24-23,.52-1,43.11,23s0,0,0,0C245.59,274.73,245.47,275.07,245.33,275.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,288.8c.15-.22.29-.44.43-.67.4-.64.8-1.29,1.18-1.94l0-.07,0,0h0c.45-.77.89-1.55,1.32-2.35,13.87-26,9.31-55.59-10.21-66-.24-.13-.49-.26-.74-.37,18.91,10.73,23.19,39.87,9.49,65.58-.43.8-.87,1.58-1.31,2.36l-42.26-22.52,26.34-49.44c-1.73-.63-3.26-.68-3.95-.1l0,0a.86.86,0,0,0-.2.26l-48.13,90.34a.87.87,0,0,0-.1.31c-.2,1.14,1.34,2.9,3.67,4.14l7,3.72c.54.29,1.1.55,1.66.81l.49.22,1.28.52.47.18c.56.21,1.13.4,1.7.57l.34.09c.47.14.95.26,1.43.37l.56.13,1.38.27.42.07c.54.08,1.07.16,1.61.21l.16,0,.59,0q.65.06,1.29.09l.65,0,.61,0h1.32l1.44-.08.51,0,1.89-.21.61-.1,1.07-.17.17,0c.49-.09,1-.2,1.46-.3l.5-.11.14,0c.37-.08.73-.18,1.09-.28s.69-.18,1-.29l.85-.26,1.23-.41.75-.27,1.31-.51.66-.28.8-.33.59-.28.63-.3.35-.16.8-.41.68-.34c.62-.33,1.25-.68,1.87-1l.13-.07c.58-.35,1.16-.7,1.74-1.07l.37-.24.84-.55h0l.57-.39h0l.1-.07.58-.41c.17-.13.35-.24.53-.37s.24-.2.37-.29c.61-.46,1.22-.93,1.83-1.42l.55-.44c.79-.65,1.57-1.33,2.34-2l0,0h0l.7-.67h0l.41-.39.18-.18.54-.53c.1-.11.22-.21.32-.32s.28-.29.42-.44c.36-.36.71-.73,1.06-1.1l.77-.85q.57-.63,1.14-1.29l.15-.18h0c.59-.71,1.18-1.43,1.76-2.17h0l.34-.45.34-.45.3-.4.21-.28c.38-.52.76-1.05,1.13-1.59l.29-.42C237.9,289.84,238.25,289.33,238.58,288.8Zm-19.47,17.92L183.3,287.64l.28-.53,36.09,19.23Zm6.91-5.45-38.93-20.74.43-.81,39.2,20.88Zm5.7-5.94-40.91-21.79,1.29-2.42,41.38,22C232.9,293.9,232.32,294.63,231.72,295.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08,278.68c-13.87,26-40.94,38.72-60.45,28.33s-24.09-39.94-10.22-66,41-38.73,60.47-28.33S246,252.63,232.08,278.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.75,
    cy: 259.85,
    rx: 44.85,
    ry: 33.61,
    transform: "translate(-125.1 311.31) rotate(-61.95)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.14,266.65h0c7.08-22.55,1.28-45.13-15.27-53.95-19.52-10.4-46.59,2.29-60.46,28.33a67.3,67.3,0,0,0-7.83,26c-1.43,17.38,4.94,33,18,40,19.51,10.4,46.58-2.28,60.46-28.33A70.15,70.15,0,0,0,237.14,266.65Zm-64.67,38.78c-11.67-6.22-17.8-19.51-17.62-34.7a64.1,64.1,0,0,1,7.75-29.08C176,216.49,202.17,204.22,221,214.27c17,9,22.24,33,13.37,56.09A68.32,68.32,0,0,1,230.9,278C217.49,303.21,191.33,315.47,172.47,305.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.59,257.19c1.8-15.29-3.52-29.22-15-35.32-16.39-8.72-39.11,1.93-50.75,23.79a57.33,57.33,0,0,0-6.19,18.49,57,57,0,0,1,6.4-20.11c11.64-21.85,34.37-32.51,50.75-23.78C229.68,226.57,235,241.27,232.59,257.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.09,278.67c-13.88,26.05-41,38.73-60.46,28.33-13.1-7-19.47-22.58-18-40,.37,1.17.78,2.41,1.26,3.69-.18,15.19,6,28.48,17.62,34.7,18.86,10,45-2.22,58.43-27.39a68.32,68.32,0,0,0,3.51-7.68q1.49-2,2.73-3.71A70.15,70.15,0,0,1,232.09,278.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.59,284.22l-1.84,7.21-4,0-.76-1.51,2.58-5.63a17.05,17.05,0,0,1-11.42-7l4.63-5a12.36,12.36,0,0,0,8.57,5l3.29-12.87c-3-1.07-8.31-4.12-8.88-7.89a22.93,22.93,0,0,1,.91-5.21c1.67-6.57,6.77-12.26,14.68-13.15l5.12-8.74.76,1.51-1.83,7.14c3.31.27,8.21,2.51,8.21,2.51l.76,1.51-3.68,6.48a13.12,13.12,0,0,0-7.06-3.55l-3.32,13a41.73,41.73,0,0,1,6.81,3.43,12.65,12.65,0,0,1,1.27,9.61A17.1,17.1,0,0,1,191.59,284.22Zm3-27.57,2.92-11.46a7.69,7.69,0,0,0-6.45,5.81C190.29,254.09,192,255.52,194.61,256.65Zm5.33,14.94c.81-3.15-1-4.65-3.64-5.77l-2.91,11.39C197.15,276.53,199.23,274.36,199.94,271.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,282.72l-1.85,7.2-4,0,1.82-7.14c-4.71-.43-8.85-2.53-10.66-5.45l3.87-6.48a12.31,12.31,0,0,0,8.57,5l3.29-12.87c-5-1.78-10.26-4.16-8-13.1,1.68-6.56,6.77-12.25,14.68-13.15l1.86-7.27,4,0-1.82,7.14a13.81,13.81,0,0,1,9,4l-3.67,6.48a13.18,13.18,0,0,0-7.07-3.55l-3.32,13c5,1.79,10.37,4.1,8.08,13A17.12,17.12,0,0,1,190.84,282.72Zm3-27.58,2.92-11.45a7.66,7.66,0,0,0-6.45,5.81C189.53,252.58,191.28,254,193.85,255.14Zm5.33,14.95c.81-3.15-1-4.65-3.64-5.78l-2.91,11.39C196.39,275,198.47,272.86,199.18,270.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08,278.68c-13.87,26-40.94,38.72-60.45,28.33s-24.09-39.94-10.22-66,41-38.73,60.47-28.33S246,252.63,232.08,278.68Z",
    style: {
      fill: "#fff",
      opacity: 0.15,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,382l.32.63c.3.61.62,1.22.94,1.81a74,74,0,0,0,4,6.53c.28.41.55.8.83,1.19l.33.46c.56.77,1.13,1.53,1.72,2.27q1.67,2.11,3.47,4c.34.37.67.73,1,1.08a5.28,5.28,0,0,0,.41.41c.23.24.46.47.7.7a58.46,58.46,0,0,0,5.08,4.47c.4.32.79.62,1.2.91l.06,0c.16.13.33.25.49.36a53.73,53.73,0,0,0,6.41,4c.52.28,1.05.55,1.57.81a46.74,46.74,0,0,0,7.9,3c.72.2,1.44.37,2.16.53a37.39,37.39,0,0,0,6.93.85c1.13,0,2.25,0,3.36-.07a31.27,31.27,0,0,0,22.35-11.68v0c11.06-13.64,12.44-36.82,2-58.18s-29.62-34.49-47.18-34.11h0a31.71,31.71,0,0,0-3.91.31,31,31,0,0,0-19,10.17l-.05.05q-1,1.15-2,2.43l-.09.13a36.05,36.05,0,0,0-3.12,5.07c-.16.3-.31.62-.46.94q-.48,1-.9,2s0,0,0,0a44.92,44.92,0,0,0-2.27,7.1c-.08.32-.15.64-.22,1q-.18.86-.33,1.74c0,.3-.1.6-.14.89-.28,1.73-.46,3.49-.57,5.29,0,.64-.06,1.29-.07,1.94s0,1.05,0,1.58c0,1.62.08,3.25.22,4.91.1,1.13.23,2.26.39,3.41.07.49.14,1,.22,1.47,0,.08,0,.15,0,.23.13.76.27,1.53.43,2.3q.6,3,1.5,6c.13.44.28.89.42,1.34,0,0,0,0,0,0,.11.35.23.71.35,1.06a70.41,70.41,0,0,0,3.24,7.94C317.15,381.61,317.26,381.83,317.36,382Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,382l.32.63c.3.61.62,1.22.94,1.81a74,74,0,0,0,4,6.53c.28.41.55.8.83,1.19l.33.46c.56.77,1.13,1.53,1.72,2.27q1.67,2.11,3.47,4c.34.37.67.73,1,1.08a5.28,5.28,0,0,0,.41.41c.23.24.46.47.7.7a58.46,58.46,0,0,0,5.08,4.47c.4.32.79.62,1.2.91l.06,0c.16.13.33.25.49.36a53.73,53.73,0,0,0,6.41,4c.52.28,1.05.55,1.57.81a46.74,46.74,0,0,0,7.9,3c.72.2,1.44.37,2.16.53a37.39,37.39,0,0,0,6.93.85c1.13,0,2.25,0,3.36-.07A31.48,31.48,0,0,0,377.88,413l9.8-4.8a2.46,2.46,0,0,0,1.3-2.82,2.64,2.64,0,0,0-.17-.47l-45.68-93.28a2,2,0,0,0-.26-.42s0,0,0-.05a2.48,2.48,0,0,0-3-.66l-9.8,4.8a31.32,31.32,0,0,0-9.59,7.3l-.05.05q-1,1.15-2,2.43l-.09.13a36.05,36.05,0,0,0-3.12,5.07c-.16.3-.31.62-.46.94q-.48,1-.9,2s0,0,0,0a44.92,44.92,0,0,0-2.27,7.1c-.08.32-.15.64-.22,1q-.18.86-.33,1.74c0,.3-.1.6-.14.89-.28,1.73-.46,3.49-.57,5.29,0,.64-.06,1.29-.07,1.94s0,1.05,0,1.58c0,1.62.08,3.25.22,4.91.1,1.13.23,2.26.39,3.41.07.49.14,1,.22,1.47,0,.08,0,.15,0,.23.13.76.27,1.53.43,2.3q.6,3,1.5,6c.13.44.28.89.42,1.34,0,0,0,0,0,0,.11.35.23.71.35,1.06a70.41,70.41,0,0,0,3.24,7.94C317.15,381.61,317.26,381.83,317.36,382Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36,382l.32.63,44.69-21.89a.71.71,0,1,0-.63-1.27l-44.68,21.88C317.15,381.61,317.26,381.83,317.36,382Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.33,325.17l21.45-10.51a.71.71,0,0,0,.25-.2.7.7,0,0,0-.71-1.12l-.16.05-18.71,9.17-.05.05q-1,1.15-2,2.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.85,333.19l28.23-13.83a.7.7,0,0,0,.33-.94.72.72,0,0,0-1-.33l-26.71,13.09Q314.27,332.16,313.85,333.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,343l34.39-16.84a.71.71,0,0,0-.62-1.28l-33.44,16.38Q311.18,342.14,311,343Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,352.72l38.86-19a.7.7,0,0,0,.32-.94.7.7,0,0,0-.94-.33l-38.23,18.72C310.24,351.66,310.23,352.19,310.24,352.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.07,362.51l42.06-20.6a.71.71,0,0,0-.63-1.27L310.85,361C310.92,361.53,311,362,311.07,362.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.47,372.39l44-21.56a.34.34,0,0,0,.14-.09.69.69,0,0,0,.19-.85.72.72,0,0,0-.95-.33L313,371c.13.44.28.89.42,1.34C313.46,372.38,313.46,372.39,313.47,372.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.86,416.14c1.13,0,2.25,0,3.36-.07L385,406.9a.71.71,0,1,0-.62-1.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,414.76c.72.2,1.44.37,2.16.53l26.72-13.09a.71.71,0,0,0-.63-1.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.3,411c.52.28,1.05.55,1.57.81l33.44-16.38a.71.71,0,0,0-.62-1.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.14,405.63c.4.32.79.62,1.2.91l.06,0,38.23-18.72a.71.71,0,0,0,.25-.2.72.72,0,0,0,.08-.75.71.71,0,0,0-.95-.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.93,399c.34.37.67.73,1,1.08l41.66-20.39a.72.72,0,0,0,.32-1,.71.71,0,0,0-.95-.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,391c.28.41.55.8.83,1.19l43.83-21.47a.71.71,0,0,0-.63-1.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.81,313.1l-1-2a10.69,10.69,0,0,0-1.56.64L330,315.26a31.32,31.32,0,0,0-9.59,7.3l-.05.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.21,330.24l26.61-13-1.44-2.93-22,10.76-.09.13A36.05,36.05,0,0,0,315.21,330.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.58,340.3l33.51-16.41-2.37-4.83L313.85,333.2A44.92,44.92,0,0,0,311.58,340.3Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.32,349.2l38-18.63-2-4-35.49,17.38C310.61,345.64,310.43,347.4,310.32,349.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.46,357.63l41.26-20.21-2-4-39.5,19.34C310.25,354.34,310.32,356,310.46,357.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,365l43.31-21.21-1-2-42.75,20.93C311.24,363.5,311.38,364.27,311.54,365Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.82,373.45l44.79-21.94-.49-1-44.66,21.87s0,0,0,0C313.58,372.74,313.7,373.1,313.82,373.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.21,388.92c.1.15.19.3.28.45.36.55.72,1.1,1.09,1.64l.21.3.29.42.33.47.33.46h0c.56.78,1.13,1.53,1.72,2.27h0l.16.18c.36.46.73.91,1.1,1.36.25.29.5.59.76.88s.69.78,1,1.17c.14.15.27.31.41.45s.21.23.32.34.35.38.53.56l.17.18a5.28,5.28,0,0,0,.41.41h0l.69.7h0l.05,0c.76.74,1.52,1.45,2.3,2.14l.55.47c.6.52,1.2,1,1.82,1.51.12.1.24.21.36.3l.53.4c.19.15.38.3.58.44l.09.07h0l.56.41h0c.27.21.55.39.83.59l.37.25c.57.4,1.15.78,1.74,1.15l.13.09c.61.38,1.24.75,1.86,1.11l.68.37.8.45.35.18.63.32.59.31.8.36.67.31,1.31.56.76.3,1.23.46.85.3,1,.32c.37.12.73.23,1.1.33l.14.05.51.12,1.47.36.18.05,1.08.21.62.12c.64.11,1.27.2,1.91.27l.52.06c.49.05,1,.09,1.46.12l.6,0c.25,0,.49,0,.74,0h1.29c.44,0,.88,0,1.31,0l.6,0h.16c.55,0,1.1-.09,1.65-.16l.43-.06c.48-.07.95-.14,1.42-.23l.57-.1q.73-.15,1.47-.33l.34-.09c.59-.15,1.17-.33,1.75-.51l.49-.17c.44-.15.88-.32,1.32-.49l.51-.2c.58-.24,1.15-.5,1.71-.77l7.22-3.54c2.41-1.18,4-2.92,3.88-4.08a.8.8,0,0,0-.09-.32l-45.83-93.59a.91.91,0,0,0-.19-.26s0,0,0-.05c-.68-.61-2.24-.61-4,0L363.9,362.3l-43.77,21.44c-.43-.8-.85-1.62-1.26-2.44-13-26.63-7.68-56.13,11.93-66.39l-.76.35c-20.22,9.9-25.89,39.81-12.68,66.78.41.82.83,1.64,1.26,2.44h0l0,0,0,.07q.56,1,1.14,2l.41.7Zm17.64,16.88,37.38-18.31.27.55-37.09,18.17Zm-7-6.08,40.6-19.88.42.83-40.33,19.75Zm-6.62-7.81,42.86-21,1.23,2.5L327,394.18C326.4,393.44,325.82,392.69,325.26,391.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.19,377.23c13.21,27,40.3,40.82,60.51,30.92s25.9-39.8,12.69-66.77-40.31-40.83-60.53-30.93S314,350.25,327.19,377.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.79,
    cy: 359.3,
    rx: 34.21,
    ry: 45.66,
    transform: "translate(-120.95 196.61) rotate(-26.09)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,377.23c13.21,27,40.31,40.81,60.52,30.92,13.57-6.65,20.59-22.3,19.74-40a68.53,68.53,0,0,0-7.05-26.73c-13.21-27-40.31-40.83-60.53-30.93-17.14,8.4-23.83,31.18-17.41,54.36h0A72.48,72.48,0,0,0,327.18,377.23Zm1.23-.61a70.78,70.78,0,0,1-3.3-7.93c-8.22-23.76-2-48,15.55-56.6,19.54-9.57,45.73,3.82,58.5,29.89A65.06,65.06,0,0,1,406,371.83c-.34,15.46-7,28.76-19.13,34.68C367.37,416.08,341.18,402.69,328.41,376.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.42,355.35c-1.3-15.62,4.6-29.6,16.45-35.41,17-8.31,39.71,3.32,50.8,26a58.42,58.42,0,0,1,5.65,19,58,58,0,0,0-5.81-20.68c-11.09-22.64-33.83-34.26-50.8-25.95C331.45,324.3,325.55,339.08,327.42,355.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,377.23c13.21,27,40.31,40.81,60.52,30.92,13.57-6.65,20.59-22.3,19.74-40-.41,1.18-.88,2.43-1.41,3.72-.34,15.46-7,28.76-19.13,34.68-19.53,9.57-45.72-3.82-58.49-29.89a70.78,70.78,0,0,1-3.3-7.93c-1-1.36-1.84-2.66-2.65-3.87A72.48,72.48,0,0,0,327.18,377.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M377.35,380.41l2.91,6.74-4,.41-1.74-1.28-1.14-5.39c-5,.13-12.22-2.59-15.94-5l1.33-5a23.75,23.75,0,0,0,11.8,3.55l-5.2-12c-3.67-.63-11-2.81-14-6.16a26.5,26.5,0,0,1-2.54-4.82c-2.65-6.14-1.33-11.86,6-13.56l-.66-8.49,1.75,1.28,2.88,6.68c3.47-.13,9.82,1.36,9.82,1.36l1.74,1.28.62,6.28a24.15,24.15,0,0,0-9.37-2.43l5.25,12.15a80.06,80.06,0,0,1,9.05,2.35,21,21,0,0,1,7.58,8.56C386,373,384.65,378.65,377.35,380.41Zm-15.16-25.32-4.63-10.7c-3.2,1-3.74,3.34-2.59,6C356.21,353.26,358.9,354.36,362.19,355.09Zm15.15,13c-1.28-3-4-4.11-7.43-4.82l4.6,10.64C377.81,372.83,378.45,370.62,377.34,368Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M375.6,379.13l2.92,6.74-4,.41-2.89-6.67a26.11,26.11,0,0,1-14.19-3.75l-.42-6.3a23.71,23.71,0,0,0,11.8,3.55l-5.2-12c-6.15-1.06-12.94-2.62-16.55-11-2.65-6.14-1.33-11.86,5.94-13.55l-2.94-6.8,4-.42L357,336a24.29,24.29,0,0,1,11.56,2.64l.61,6.28a24.29,24.29,0,0,0-9.36-2.43L365,354.66c6.15,1.06,13,2.55,16.62,10.91C384.3,371.7,382.9,377.38,375.6,379.13Zm-15.16-25.32-4.62-10.7c-3.21,1-3.74,3.34-2.6,6C354.47,352,357.15,353.08,360.44,353.81Zm15.15,12.95c-1.27-2.95-4-4.11-7.42-4.82l4.6,10.64C376.07,371.55,376.71,369.35,375.59,366.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.71,349.31l-80-21c3.28-7.91,8.74-14.25,16.17-17.89,20.22-9.9,47.32,3.95,60.53,30.93A72.88,72.88,0,0,1,403.71,349.31Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.44,361.81a54.35,54.35,0,1,1-54.34-54.35A54.34,54.34,0,0,1,318.44,361.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.09,
    cy: 361.81,
    r: 45.62,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.83,348.6h0a54.42,54.42,0,1,0,1.61,13.22A54.38,54.38,0,0,0,316.83,348.59ZM264.1,414.33a52.54,52.54,0,1,1,52.52-52.52A52.47,52.47,0,0,1,264.1,414.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.33,342.29a45.62,45.62,0,0,0-81.68,40.63,45.62,45.62,0,1,1,81.68-40.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.44,361.81A54.35,54.35,0,0,1,217,388.9c1.18.88,2.48,1.79,3.87,2.72a52.53,52.53,0,0,0,95.07-38.38c.36-1.64.65-3.2.91-4.64A54.25,54.25,0,0,1,318.44,361.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268,386.44v7.46h-5.46L261,392.36l1.55-5.85c-6.53-.4-14.41-4.08-17.88-7.08l4.55-5.19a25.63,25.63,0,0,0,13.33,5.07V366c-4.41-1.07-12.67-4.17-14.75-8.06a18.25,18.25,0,0,1-.58-5.4c0-6.8,4.93-12.73,15.33-13.73l3.92-9.08,1.54,1.55v7.4c4.57.24,12,2.51,12,2.51l1.54,1.55-2.73,6.73a27.64,27.64,0,0,0-10.8-3.6v13.47a89.61,89.61,0,0,1,10.43,3.48,13.73,13.73,0,0,1,5,9.91C283.5,379.51,278.5,385.37,268,386.44Zm-5.46-28.52V346.05c-4.73.74-6.73,3.14-6.73,6.07C255.84,355.32,258.7,356.78,262.57,357.92ZM275,373.31c0-3.26-2.94-4.8-6.94-5.93v11.8C272.9,378.44,275,376.18,275,373.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,384.89v7.47H261V385c-6.53-.4-12.86-2.53-16.33-5.53l3-6.73A25.71,25.71,0,0,0,261,377.76V364.43c-7.4-1.8-15.33-4.2-15.33-13.46,0-6.8,4.94-12.73,15.33-13.73v-7.53h5.47v7.4A28.53,28.53,0,0,1,280,341.17l-2.74,6.73a27.63,27.63,0,0,0-10.79-3.59v13.46c7.39,1.8,15.46,4.13,15.46,13.39C282,378,277,383.83,266.49,384.89ZM261,356.37V344.51c-4.73.73-6.73,3.13-6.73,6.06C254.29,353.77,257.16,355.24,261,356.37Zm12.4,15.39c0-3.26-2.93-4.8-6.93-5.93v11.8C271.35,376.89,273.42,374.63,273.42,371.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.4,324.28,222.64,397a54.34,54.34,0,0,1,80.76-72.67Z",
    style: {
      fill: "#fff",
      opacity: 0.15,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.51 188.29 221.99 187.2 214.51 186.1 216.36 183.18 213.44 185.03 212.35 177.56 211.25 185.03 208.33 183.18 210.18 186.1 202.71 187.2 210.18 188.29 208.33 191.21 211.25 189.36 212.35 196.84 213.44 189.36 216.36 191.21 214.51 188.29",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.51 188.29 221.99 187.2 214.51 186.1 216.36 183.18 213.44 185.03 212.35 177.56 211.25 185.03 208.33 183.18 210.18 186.1 202.71 187.2 210.18 188.29 208.33 191.21 211.25 189.36 212.35 196.84 213.44 189.36 216.36 191.21 214.51 188.29",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.87 241.41 252.2 239.9 241.87 238.38 244.42 234.35 240.39 236.9 238.87 226.57 237.36 236.9 233.32 234.35 235.88 238.38 225.55 239.9 235.88 241.41 233.32 245.44 237.36 242.89 238.87 253.22 240.39 242.89 244.42 245.44 241.87 241.41",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.87 241.41 252.2 239.9 241.87 238.38 244.42 234.35 240.39 236.9 238.87 226.57 237.36 236.9 233.32 234.35 235.88 238.38 225.55 239.9 235.88 241.41 233.32 245.44 237.36 242.89 238.87 253.22 240.39 242.89 244.42 245.44 241.87 241.41",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.85 390.89 67.02 390.13 61.85 389.37 63.13 387.36 61.11 388.63 60.35 383.47 59.6 388.63 57.58 387.36 58.85 389.37 53.69 390.13 58.85 390.89 57.58 392.9 59.6 391.63 60.35 396.79 61.11 391.63 63.13 392.9 61.85 390.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.85 390.89 67.02 390.13 61.85 389.37 63.13 387.36 61.11 388.63 60.35 383.47 59.6 388.63 57.58 387.36 58.85 389.37 53.69 390.13 58.85 390.89 57.58 392.9 59.6 391.63 60.35 396.79 61.11 391.63 63.13 392.9 61.85 390.89",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.38 340.77 163.16 339.49 154.38 338.2 156.55 334.77 153.12 336.94 151.84 328.17 150.55 336.94 147.12 334.77 149.29 338.2 140.52 339.49 149.29 340.77 147.12 344.2 150.55 342.03 151.84 350.81 153.12 342.03 156.55 344.2 154.38 340.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.38 340.77 163.16 339.49 154.38 338.2 156.55 334.77 153.12 336.94 151.84 328.17 150.55 336.94 147.12 334.77 149.29 338.2 140.52 339.49 149.29 340.77 147.12 344.2 150.55 342.03 151.84 350.81 153.12 342.03 156.55 344.2 154.38 340.77",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.97 322.59 335.46 321.34 326.97 320.1 329.07 316.78 325.75 318.88 324.51 310.39 323.26 318.88 319.94 316.78 322.04 320.1 313.55 321.34 322.04 322.59 319.94 325.91 323.26 323.81 324.51 332.3 325.75 323.81 329.07 325.91 326.97 322.59",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.97 322.59 335.46 321.34 326.97 320.1 329.07 316.78 325.75 318.88 324.51 310.39 323.26 318.88 319.94 316.78 322.04 320.1 313.55 321.34 322.04 322.59 319.94 325.91 323.26 323.81 324.51 332.3 325.75 323.81 329.07 325.91 326.97 322.59",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.01 258.72 416.01 257.7 409.01 256.67 410.74 253.94 408.01 255.67 406.98 248.67 405.96 255.67 403.22 253.94 404.95 256.67 397.96 257.7 404.95 258.72 403.22 261.46 405.96 259.73 406.98 266.72 408.01 259.73 410.74 261.46 409.01 258.72",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.01 258.72 416.01 257.7 409.01 256.67 410.74 253.94 408.01 255.67 406.98 248.67 405.96 255.67 403.22 253.94 404.95 256.67 397.96 257.7 404.95 258.72 403.22 261.46 405.96 259.73 406.98 266.72 408.01 259.73 410.74 261.46 409.01 258.72",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.33 392.75 446.66 391.24 436.33 389.73 438.89 385.69 434.85 388.25 433.34 377.92 431.83 388.25 427.79 385.69 430.35 389.73 420.02 391.24 430.35 392.75 427.79 396.79 431.83 394.24 433.34 404.56 434.85 394.24 438.89 396.79 436.33 392.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.33 392.75 446.66 391.24 436.33 389.73 438.89 385.69 434.85 388.25 433.34 377.92 431.83 388.25 427.79 385.69 430.35 389.73 420.02 391.24 430.35 392.75 427.79 396.79 431.83 394.24 433.34 404.56 434.85 394.24 438.89 396.79 436.33 392.75",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.8 393.71 233.13 392.2 222.8 390.68 225.36 386.65 221.32 389.2 219.81 378.87 218.29 389.2 214.26 386.65 216.81 390.68 206.48 392.2 216.81 393.71 214.26 397.74 218.29 395.19 219.81 405.52 221.32 395.19 225.36 397.74 222.8 393.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.8 393.71 233.13 392.2 222.8 390.68 225.36 386.65 221.32 389.2 219.81 378.87 218.29 389.2 214.26 386.65 216.81 390.68 206.48 392.2 216.81 393.71 214.26 397.74 218.29 395.19 219.81 405.52 221.32 395.19 225.36 397.74 222.8 393.71",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.e3ddc72944045f2d7f1a30782d006e3d.svg";
export { ForwardRef as ReactComponent };